/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';

import {
  AxiosServiceResponse,
  PagedList,
  ServiceResponse
} from 'interfaces/general';

const instance = axios.create({
  baseURL: `${process.env.CATALOGS_SERVICE_ENDPOINT}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

/* REQUESTS */

export interface IParamsFilter {
  productIds?: number[];
  reportType?: string;
  pendingReasonLevel?: number;
  equipmentTypeId?: number;
  LocationId?: number;
  workFlowOrderStateIds?: string;
  startDate?: Date | string;
  endDate?: Date | string;
  unitMeasurement?: number[];
  text?: string;
  pageSize?: number;
  orderColumn?: string;
  pageNumber?: number;
  descending?: boolean;
  enabled?: boolean | null;
  isEnabled?: boolean | null;
  search?: string;
  name?: string;
  serviceName?: string;
  equipmentTypeIds?: number[];
  serviceTypesIds?: number[];
  currencyIds?: number[];
  serviceTypeId?: number;
  frequentFailureId?: number;
  responsibleTypeId?: number;
  warehouseId?: number;
  engineerId?: number;
  productStatusId?: number[];
  productConditionId?: number[];
  hasAdvancedSearch?: boolean;
  field?: string;
  equals?: boolean | string;
  contains?: string;
  clientId?: null | number;
  searhText?: null | string;
  countryId?: null | number;
  priorityId?: null | number;
  stateId?: null | number;
  regionId?: null | number;
  municipalityId?: null | number;
  areaId?: number;
  FromDate?: Date | null;
  ToDate?: Date | null;
  TokenTypeId?: string;
  AreaId?: number | null;
  Username?: string;
  FullName?: string;
  partnerId?: number;
  warehouseAdminUserId?: number[];
  warehouseTypeId?: number | number[];
  productStatusIds?: number[];
  productConditionIds?: number[];
  userGroupId?: number;
  isLab?: boolean;
  description?: string;
  interventionCodeLevelId?: number;
  responsibleId?: number;
  unitMeasurementIds?: number[];
  supplyId?: number;
  isExport?: boolean;
  project?: number;
  statusIds?: number[];
  fieldToSearch?: string;
  kitStatusIds?: number[];
  projectId?: number;
  partnerIds?: number[];
  shipmentId?: (number | number[])[];
  workFlowId?: number;
  textType?: number;
  laboratoryTechnicianId?: number;
  ticketStatusId?: number;
  ticketStatusCategoryId?: number;
  FormFieldId?: number | string;
  SearchDynamicFields?: boolean;
  DynamicFieldValue?: string;
  AdvancedSearchText?: string;
  title?: string;
  changeTypeIds?: number[];
  changeStageIds?: number[];
  changeStatusIds?: number[];
  systemUserId?: number;
}

/* RESPONSE */
export interface FrequentFailure {
  id: number;
  serviceTypeId: number;
  ffgroup: string;
  name: string;
  enabled: boolean | null;
}

export interface FFOpeningFields {
  id: number;
  name: string;
  itemOrder: number;
  required: boolean;
  enabled: boolean;
  frequentFailureId: number;
  frequentFailureName: string;
  key?: string;
}

export interface FrequentFailureFields {
  id: number;
  serviceTypeId: number;
  ffgroup: string;
  name: string;
  enabled: boolean | null;
}

export interface JobSubCategories {
  jobCategoryId: number;
  jobCategoryName: string;
  name: string;
  id: number;
  enabled: boolean;
}

export interface Origin {
  id: number;
  origen: string;
}

export interface ICatalogEntity {
  id: number;
  name: string;
}

export interface ServiceType {
  idSurvey: number;
  id?: number;
  serviceClassId?: number;
  name: string;
  hasFrequentFailure?: boolean;
  enabled?: boolean;
}

export interface SurveyType {
  IdSurvey: number;
  IdServiceType: number;
}

export interface ServiceTypeByServiceName {
  serviceTypeId: number;
  serviceTypeName: string;
}

export interface ObtainRelatebleServiceTypesByOtherService {
  id?: number;
  name?: string;
  hasFrequentFailure?: boolean;
  enabled?: boolean;
}

export interface PriorityItem {
  id?: number;
  name?: string;
  enabled?: boolean;
  equipmentTypeId?: number;
  equipmentTypeName?: string;
}

export interface CreateJobSubCategoryItem {
  id?: number;
  name: string;
  clientJobCategoryId: number;
}

export interface EditJobSubCategoryItem {
  id?: number;
  name: string;
  clientJobCategoryId: number;
  enabled?: boolean;
  jobSubCategoryId?: number;
  jobCategoryId?: number;
  jobCategoryName?: string;
}

export interface IJobSubCategoryParams extends IParamsFilter {
  jobSubCategoryId?: number;
  jobCategoryId?: number;
}

export interface Currency extends ICatalogEntity {
  id: number;
  iso: string;
  name: string;
  itemOrder: number | null;
  enabled: boolean | null;
}

export interface PaymentType extends ICatalogEntity {
  id: number;
  name: string;
  itemOrder: number | null;
  enabled: boolean | null;
}

/* Reasons - Request & Response */
export interface Reason {
  id: number;
  description: string;
}
export interface ReasonType {
  id?: number;
  description: string;
  base?: boolean;
  enabled?: boolean;
}

export interface IReasonByFilterResponse extends Reason {
  reasonTypeId: number;
  reasonTypeDescription: number | null;
  enabled: boolean | null;
}
export interface IReasonByFilterRequest extends IParamsFilter {
  reasonId?: number;
  reasonTypeId?: number | number[];
}
export interface IEditReasonRequest {
  description: string;
  reasonId: number;
  enabled: boolean;
  serviceType?: string;
  countries: CountryForm[];
}

export interface IRemoveReasonRequest {
  id: number;
}

export interface ICreateReasonRequest {
  description: string;
  reasonTypeId: number;
  createdUserId?: number;
}

/* TicketCommentTypes - Request & Response */
export interface ICommentTypesRequest extends IParamsFilter {
  ticketcommentTipeId?: number;
  name?: string;
}

/* Site - Request & Response */
export interface IEditSite extends PriorityItem {
  siteId?: number;
}

export interface SearchSiteResponse {
  id: number;
  name: string;
  enabled: boolean;
}

/* - - - */

export interface getAssignableTaskForceByProject {
  systemUserId: number;
  name: string;
}

export interface CouriersOption {
  id: number;
  description: string;
}

export interface ShipmentPriorityOption {
  id: number;
  description: string;
}

export interface ResponsibleType {
  id: number;
  name: string;
  enabled?: boolean;
}

export interface OperationTypeResponse {
  id: number;
  name: string;
}

export interface AceptRejectDetailData {
  id?: number;
  description?: string;
}

export interface ShipmentStateOption {
  id: number;
  name: string;
}

export interface FrecuentlyFailureResponse {
  id: number;
  serviceTypeId: number;
  serviceTypeName: string;
  ffGroup: string;
  name: string;
  createdDateTime: Date;
  enabled?: boolean;
}

export interface ServiceNameResponse {
  id?: number;
  name?: string;
  serviceTypeId?: number;
  serviceTypeName?: string;
  enabled?: boolean;
}

export interface RemoveFrequentFailureResponse {
  message: string;
  data: {
    message: string;
  };
  isError: boolean;
}

export interface RemoveJobSubCategoryResponse {
  message: string;
  data: {
    message: string;
  };
  isError: boolean;
}

export interface RemoveBrandResponse {
  message: string;
  data: {
    message: string;
  };
  isError: boolean;
}

export interface EditFrequentFailureResponse {
  message: string;
  data: {
    message: string;
  };
  isError: boolean;
}

export interface ServiceTypesQueryParams {
  ServiceId?: number;
  text?: string;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  enabled?: boolean | null;
  isExport?: boolean;
}

export interface BrandQueryParams {
  brandId?: number;
  text?: string;
  enabled?: boolean | null;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  isExport?: boolean;
}

export interface ModelQueryParams {
  enabled?: null | boolean;
  currencyIds?: number[];
  equipmentTypeIds?: number[];
  brandIds?: number[];
  text?: null | string;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  isExport?: boolean;
}

export interface ModelItem {
  id?: number;
  name?: string;
  description?: string;
  sku?: string;
  brandId?: number;
  equipmentTypeId?: number;
  currencyId?: number;
  cost?: number;
  amount?: number;
  enabled?: boolean;
  logoBlobStorageUrlPath?: string;
  logo?: string;
  countries: CountryForm[];
}

export interface GetAllModelsResponse {
  id: number;
  name: string;
  productBrandId: number;
  productBrandName: string;
}

export interface ModelSearchedByBrand {
  id: number;
  name: string;
  description: string;
}

export interface ModelGetResponse {
  id?: number;
  name?: string;
  enabled?: boolean;
  sku?: string;
  brandId?: number;
  brandName?: string;
  equipmentTypeId?: number;
  equipmentTypeName?: string;
  cost?: {
    amount?: number;
    currencyName?: string;
    currencyId?: number;
  } | null;
  description?: string;
  logoBlobStorageUrlPath?: null;
  countries: CountryForm[];
}

export interface PriorityQueryParams {
  id?: number;
  enabled?: null | boolean;
  name?: null | string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
}

export interface CreateDataServiceNameRequest {
  clientJobCategoryId: number;
  name: string;
}

export interface CreateFreqFailureResponse {
  frequentFailureId: number;
  createdDateTimeUTC: Date;
}

export interface CreateDataFreqFailureRequest {
  serviceTypeId: number;
  name: string;
}

export interface IFreqFailureFields {
  frequentFailureId: number;
  fields: {
    name: string;
    required: boolean;
    itemOrder: number;
  }[];
}

export interface FreqFailureFieldsToDelete {
  frequentFailureId: number;
  fieldsIds: number[];
}

export interface EditFreqFailure {
  frequentFailureId: number;
  serviceTypeId: number;
  name: string;
  enabled?: boolean;
}

export interface SearchBrandsResponse {
  enabled: boolean;
  id: number;
  modelsQuantity: number;
  name: string;
  countries: Countries[];
}

export interface Countries {
  countryId: number;
  countryName: string;
}

export interface CountryForm {
  checked?: boolean;
  countryId: number;
  countryName: string;
}

export interface CreateBrandRequest {
  name: string;
}

export interface CreateBrandResponse {
  frequentFailureId: number;
  createdDateTimeUTC: Date;
}

export interface EditBrandsResponse {
  brandId: number;
  name: string;
  enabled: boolean;
  countryIds: number[];
}

export interface ListCurrenciesResponse {
  id: number;
  name: string;
  iso: string;
  enabled: boolean;
}

export interface SearchArea {
  areaId?: number | null;
  text?: string;
  enabled?: boolean;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
}

export interface SearchAreaResponse {
  impactId: number;
  priorityId: number;
  ticketPriorityId?: number;
  urgencyId: number;
  id: number;
  name: string;
  description?: string;
  enabled: boolean;
}

export interface SearchAreaManager {
  pageNumber?: number;
  pageSize?: number;
  descending?: boolean;
  enabled?: boolean;
  isExport?: boolean;
  orderColumn?: string;
}

export interface SearchAreaManagerResponse {
  id: number;
  name: string;
  enabled: boolean;
  firstLastName: string;
  emailRegionalDirector: string;
  emailBranchManager: string;
  secondLastName: string;
}

export interface SaveAreaManager {
  name: string;
  firstLastName: string;
  secondLastName: string;
}

export interface EditAreaManager {
  name: string;
  firstLastName: string;
  secondLastName: string;
  enabled: boolean;
}

export interface ClientClassification {
  priorityId: number;
  priorityName: string;
  enabled: true;
}

export interface ProjectResponse {
  id: number;
  name: string;
  description: string;
  partnerId: number;
  partnerName: string;
  enabled: boolean;
  companyName: string;
}

export interface EditProject {
  id: number;
  name: string;
  description: string;
  partnerId: number;
  enabled: boolean;
  companyName: string;
}

export interface CreateProject {
  projectId: number;
  name: string;
  partnerId: number;
  description: string;
  companyName: string;
}

export interface PrioritiesTypes {
  id: number;
  name: string;
  enabled: boolean;
}

export interface CreateStatusRequest {
  name: string;
  ticketStatusCategoryId: number;
  description: string;
  itemOrder: number;
  hexColor: string;
  impactSLA: boolean;
}

export interface EditStatusRequest {
  ticketStatusId: number;
  name: string;
  hexColor: string;
  enabled: boolean;
  description?: boolean;
  ticketStatusCategoryId?: number;
  base: boolean;
  impactSLA: boolean;
}

export interface WorkFlowOrderStates {
  id: number;
  name: string;
}

export interface WorkFlowTypeResponse {
  id: number;
  name: string;
  clientId: number;
  clientName: string;
  enabled: boolean;
  label?: string;
}

export interface CreateWorkFlowType {
  clientId: number;
  name: string;
}

export interface EditWorkFlowType {
  id: number;
  name?: string;
  clientId?: number;
  enabled?: boolean;
}

export interface ProductConditionItem {
  id: number;
  name: string;
  productStatusId: number;
  productStatus: string;
  enabled: boolean;
}

export interface CreateProductCondition {
  name: string;
  productStatusId: number;
}

export interface EditProductCondition {
  productConditionId: number;
  name?: string;
  productStatusId?: number;
  enabled?: boolean;
}

export interface ProductStatus {
  id: number;
  name: string;
  enabled: boolean;
  isLab?: boolean;
}

export interface OperationType {
  operationTypeId?: number;
  enabled?: boolean;
}

export interface OperationTypeRequest {
  serviceId?: number;
  operationTypes?: OperationType[];
}

export interface StatusItem {
  id: number;
  description: string;
  enabled: boolean;
  name: string;
  editable: boolean;
  hexColor: string;
  ticketStatusCategory: string;
}

export interface GetAllStatus {
  id?: number;
  name?: string;
  enabled?: boolean;
  base?: boolean;
}

export interface UnitsOfMeasurementResponse {
  id?: number;
  name?: string;
  quantityApply?: number;
  enabled?: boolean;
}

export interface InterventionCodesResponse {
  id: number;
  interventionCodeLevelId: number;
  description: string;
  name?: string;
  coreKey: string;
  enabled: boolean;
}

export interface ReasonPendingForReasonResponse {
  id: number;
  interventionCodeLevelId: number;
  description: string;
  enabled: boolean;
}

export interface CreateInterventionCodesRequest {
  interventionCodeLevelId?: number;
  interventionCodeRootId?: number;
  coreKey?: string;
  categoryId?: number;
  name?: string;
  description?: string;
  enabled?: boolean;
}

export interface CancelationReason {
  id: number;
  nivel: string;
  description: string;
  enabled: boolean;
}

export interface categoryActive {
  id: number;
  name: string;
  description: string;
  enabled: boolean;
}

export interface PendingReason {
  id: number;
  nivel: string;
  description: string;
  enabled: boolean;
}

export interface ReasonReasonPendingForReasonResponse {
  id: number;
  interventionCodeLevelId?: number;
  description: string;
  enabled: boolean;
}

export interface CancelationReasonResponse {
  id: number;
  interventionCodeLevelId?: number;
  description: string;
  enabled: boolean;
}
export interface ChildCancelationReason {
  id: number;
  name: string;
  description: string;
  categoryId?: number;
  enabled: boolean;
  rootLevelId: number;
  rootLevel: string;
  rootLevelName: string;
}

export interface CreateReasonPendingForReasonRequest {
  interventionCodeRootId?: number;
  description?: string;
  enabled?: boolean;
}

export interface CreateCancelationReasonResponseRequest {
  interventionCodeRootId?: number;
  categoryId?: number;
  name?: string;
  description?: string;
  enabled?: boolean;
}

export interface ScheduledReasonResponse {
  id?: number;
  nivel?: string;
  description?: string;
  enabled?: boolean;
  rootLevelId?: null;
  rootLevel?: null;
  rootLevelName?: null;
}

export interface ScheduledReasonUpdateRequest {
  scheduledReasonId: number;
  description: string;
  enabled: boolean;
}

export interface PendingForSerialReason {
  id: number;
  description: string;
  enabled: boolean;
}

export interface PendingForSerialReasonUpdateRequest {
  pendingSerieReasonId: number;
  description: string;
  enabled: boolean;
}

export interface PartnerResponse {
  id?: number;
  name?: string;
  countryIcon?: string;
  countryId?: number;
  countryName?: string;
  fileDescriptorId?: number;
  blobStorageUrlPath?: string;
  enabled?: boolean;
}

export interface PartnerByUserId {
  id?: number;
  name?: string;
  countryIcon?: string;
}

export interface EditEquipmentType {
  equipmentTypeId: number;
  name: string;
  enabled: boolean;
}

export interface CreateReparationType {
  name: string;
  equipmentTypeId: number;
}

export interface EditReparationType {
  reparationTypeId: number;
  name: string;
  enabled: boolean;
}

export interface ServiceTypeClosingFieldsRequest {
  serviceTypeId?: number;
  fields?: Field[];
}

export interface Field {
  name?: string;
  required?: boolean;
  itemOrder?: number;
  isVisibleInPdf?: boolean;
}

export interface GetServiceTypeClosingFieldsResponse {
  id?: number;
  name?: string;
  itemOrder?: number;
  required?: boolean;
  enabled?: boolean;
  serviceTypeId?: number;
  serviceTypeName?: string;
  isVisibleInPdf?: boolean;
  key?: string;
}

export interface ServiceTypeClosingFieldsRequestDelete {
  serviceTypeId?: number;
  fieldsIds?: number[];
}

export interface AuditType {
  id: number;
  description: string;
  enabled: boolean;
}

export interface RequestGeneralSearchAudit {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  auditTypeId?: number;
  enabled?: boolean;
  description?: string;
}

export interface RequestUpdateAuditType {
  auditTypeId?: number;
  description?: string;
  enabled?: boolean;
}

export interface ResponseGeneralSearchAuditType {
  id?: number;
  description?: string;
  enabled?: boolean;
}

export interface WareHouseTypeRequest {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  warehouseTypeId?: number;
  enabled?: boolean;
  description?: string;
}

export interface WareHouseTypeResponse {
  id?: number;
  description?: string;
  enabled?: boolean;
}

export interface WareHouseTypeCreateRequest {
  description?: string;
  partnerId?: number;
}

export interface WareHouseTypeUpdateRequest {
  warehouseTypeId?: number;
  partnerId?: number;
  description?: string;
  enabled?: boolean;
}

export interface UnitsMeasurementRequest {
  text?: string;
  pageNumber?: number;
  pageSize: number;
  orderColumn: string;
  descending?: boolean;
  isExport?: boolean;
  id?: number;
  name?: string;
  enabled: boolean;
}

export interface UnitsMeasurementResponse {
  id: number;
  name: string;
  quantityApply: number;
  enabled: boolean;
}

export interface UnitsMeasurementCreateRequest {
  name?: string;
}

export interface UnitsMeasurementUpdateRequest {
  unitMeasurementId: number;
  name: string;
  enabled: boolean;
}

export interface NotificationPriorityAndTypeData {
  id: number;
  name: string;
  enabled: boolean;
}

export interface GetTagCodesRequest {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  tagCodeId?: number;
  enabled?: boolean;
}

export interface GetTagCodesResponse {
  id: number;
  number: number;
  enabled: boolean;
}

export interface CreateFolioTag {
  numbers: number[];
}

export interface EditTagCode {
  tagCodeId: number;
  number: number;
  enabled: boolean;
}

export interface GetFuelCodesRequest {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  fuelCodeId?: number;
  enabled?: boolean;
}

export interface GetFuelCodesResponse {
  id: number;
  number: number;
  enabled: boolean;
}

export interface CreateFolioFuel {
  number: number;
}

export interface DeleteAndCreateFolioFuel {
  numbers: number[];
}

export interface EditFuelCode {
  fuelCodeId: number;
  number: number;
  enabled: boolean;
}

export interface GetExpenseCodeRequest {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  expenseCodeId?: number;
  enabled?: boolean;
}

export interface GetExpenseCodeResponse {
  id: number;
  number: number;
  enabled: boolean;
}

export interface CreateFolioExpenseCode {
  number: number;
}

export interface DeleteAndCreateFolioExpenseCode {
  numbers: number[];
}

export interface EditExpenseCode {
  expenseCodeId: number;
  number: number;
  enabled: boolean;
}

export interface GetDashboardRequest {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  dashboardId?: number;
  urlPath?: string;
  accessElemnetId?: number;
  enabled?: boolean;
}

export interface GetDashboardResponse {
  id?: number;
  name?: string;
  urlPath?: string;
  accessElementId?: number;
  accessElementName?: string;
  enabled?: boolean;
}

export interface CreateDashboard {
  name?: string;
  urlPath?: string;
  accessElementId?: number;
}
export interface EditDashboard {
  dashboardId?: number;
  name?: string;
  urlPath?: string;
  accessElementId?: number;
  enabled?: boolean;
}

export interface SearchGeneratedReportsRequest {
  text: string;
  pageNumber: number;
  pageSize: number;
  orderColumn: string;
  descending: boolean;
  isExport: boolean;
  generatedReportId?: number;
  generatedReportGuid?: string;
  generatedReportType?: string;
  generatedReportStatus?: string;
  withError?: boolean;
  enabled?: boolean;
  fromDateTime?: string;
  toDateTime?: string;
  startDateTime?: string;
  endDateTime?: string;
}

export interface GeneratedReport {
  id: number;
  guid: string;
  userName: string;
  reportType: string;
  fileName: string;
  fileLink: string;
  startDateTime: string;
  endDateTime: string;
  reportStatus: string;
  reportWithError: boolean;
  message: string;
  itemsCount: number;
  enabled: boolean;
}

export interface SaveReportWithErrorRequest {
  generatedReportGuid: string;
  message: string;
}

export interface TicketStatus {
  categoryId: number;
  categoryName: string;
  ticketStatuses: {
    base: boolean;
    description: string;
    name: string;
    hexColor: string;
    id: number;
    ticketStatusId: number;
  }[];
}

export interface GetAllLanguages {
  languageId?: number;
  name?: string;
  culture?: string;
}

export interface ItemsOfForms {
  id: number;
  name: string;
  fieldTypeName: string;
  fieldTypeId: number;
  required: boolean;
  itemOrder: number;
  options: [];
  default?: boolean;
  fieldTypeDesc?: string;
}

export interface ResponseForm {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalCount: number;
  hasPrevious: boolean;
  hasNext: boolean;
  items: ItemsOfForms[];
}

export interface FormCustomRequest {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  formId?: number;
}

export interface FormCriticality {
  impactId?: string;
  urgencyId?: string;
}

export interface ServiceClassParams {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  serviceClassId?: number;
  enabled?: boolean;
}

export interface ServiceClassResponse {
  id?: number;
  name?: string;
  isTowerService?: boolean;
  enabled?: boolean;
}

export interface TowerModel {
  id?: number;
  towerModelId?: number;
  name?: string;
  description?: string;
  towerTypeId?: number;
  towerTypeName?: string;
  enabled?: boolean;
}

export interface TowerType {
  id?: number;
  towerTypeId?: number;
  name?: string;
  description?: string;
  enabled?: boolean;
}

export interface TowerProperty {
  id?: number;
  towerPropertyId?: number;
  name?: string;
  description?: string;
  enabled?: boolean;
}

export interface TowerModelGeneralSearch {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  id?: number;
  name?: string;
  enabled?: boolean;
  description?: string;
}

export interface ChangeTypeParams {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  ChangeTypeId?: number;
  enabled?: boolean;
}

export interface ChangeTypesResponse {
  id?: number;
  name?: string;
  description?: string;
  preApproved?: boolean;
  predefined?: boolean;
}

export interface ChangeTypesEditResponse {
  id?: number;
  name?: string;
  description?: string;
  preApproved?: boolean;
}

export interface ChangeStageStatusParams {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  default?: boolean;
  enabled?: boolean;
  userLangId?: number;
}

export interface ChangeStageStatusResponse {
  id?: number;
  stageId?: number;
  name?: string;
  description?: string;
  default?: boolean;
  enabled?: boolean;
  statuses?: number;
}

export interface ChangeStatusParams {
  text?: string;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
  stageRouteId?: number;
}

export interface ChangeStatusResponse {
  statusId?: number;
  name?: string;
  description?: string;
  enabled?: boolean;
  stageRouteId?: number;
}

export interface CreateNewStatus {
  stageRouteId?: number;
  name?: string;
  description?: string;
}

export interface CreateNewStage {
  name?: string;
  description?: string;
}

export interface EditStatus {
  stageId?: number;
  name?: string;
  description?: string;
}

export interface EditStage {
  stageId?: number;
  name?: string;
  description?: string;
}

export interface TaskStatusResponse {
  id?: number;
  name?: string;
  enabled?: boolean;
  hexColor?: string;
  taskStatusCategoryId?: number;
}

export interface TaskTypeResponse {
  id?: number;
  name?: string;
  enabled?: boolean;
}

export interface TicketPriorityResponse {
  id?: number;
  name?: string;
  description?: string;
  enabled?: boolean;
}

export interface SearchTaskStatusRequest {
  TaskStatusId: number;
  Name: string;
  Enabled: boolean;
  TaskStatusCategoryId: number;
  Text: string;
  PageNumber: number;
  PageSize: number;
  OrderColumn: string;
  Descending: boolean;
  IsExport: boolean;
}

export interface SearchTaskStatusResponse {
  id?: number;
  name?: string;
  enabled?: boolean;
  hexColor?: string;
  taskStatusCategoryId?: number;
}

export interface SolutionTopicsResponse {
  id?: number;
  name?: string;
  enabled?: boolean;
}

export interface IPriorityByUrgencyAndImpact {
  assignedPriorityId?: number;
  priorityId?: number;
  priorityName?: string;
}

/* API */
export default {
  instance,
  currencies: {
    /**
     * No description
     *
     * @tags Currencies
     * @name List
     * @request GET:/api/v1/Currencies
     * @secure
     */
    list: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ListCurrenciesResponse[]>>({
        url: `/Currencies`,
        method: 'GET',
        ...config
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name Detail
     * @request GET:/api/v1/Currencies/{id}
     * @secure
     */
    detail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, any>({
        url: `/Currencies/${id}`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE TODAS LAS MONEDAS
     * @tags Monedas
     * @name GeneralSearch
     * @request GET:/api/v1/catalog/api/v1/Currencies
     * @secure
     */
    GetAllCurrencies: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Currency[]>>({
        url: `/Currencies`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE TODAS LAS MONEDAS PAGINADAS
     * @tags Monedas
     * @name GeneralSearch
     * @request POST:/api/v1/Currencies/GeneralSearch
     * @secure
     */
    GetAllCurrencySearch: (params: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<Currency>>>({
        url: `/Currencies/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * CREA UNA MONEDA
     *
     * @tags Currencies
     * @name Currencies
     * @request POST: /api/v1/Currencies
     * @secure
     */
    CreateCurrency: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<CreateFreqFailureResponse>>({
        url: `/Currencies`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * ACTUALIZA UNA MONEDA
     *
     * @tags Currencies
     * @name Currencies
     * @request PUT: /api/v1/Currencies/0
     * @secure
     */
    UpdateCurrency: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<CreateFreqFailureResponse>>({
        url: `/Currencies`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * ELIMINA UNA MONEDA
     *
     * @tags Currencies
     * @name Currencies
     * @request DELETE: /api/v1/Currencies/Id
     * @secure
     */
    RemoveConcurrency: (
      concurrencyId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<RemoveFrequentFailureResponse>
      >({
        url: `/Currencies/${concurrencyId}`,
        method: 'DELETE',
        ...config
      })
  },
  frequentFailure: {
    /**
     * TRAE TODOS LOS TIPOS DE FALLA POR EL ID DEL TIPO DE SERVICIO
     *
     * @tags FrequentFailure
     * @name serviceTypeIdDetail
     * @request GET:/api/v1/FrequentFailure/ServiceTypeId/{id}
     * @secure
     */
    serviceTypeIdDetail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<FrequentFailure[]>>({
        url: `/FrequentFailure/ServiceTypeId/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Trae las fallas frecuentes
     *
     * @tags GetFrequentFailures
     * @name GetFrequentFailures
     * @request POST:api/v1/FrequentFailure/GetFrequentFailures
     * @secure
     */
    GetFrequentFailures: (
      data: {
        frequentFailureId?: number;
        serviceTypeId: number;
        enabled?: boolean;
        pageNumber?: number;
        pageSize?: number;
        orderColumn?: string;
        descending?: boolean;
        text?: string;
        isExport?: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<FrecuentlyFailureResponse>>
      >({
        url: `/FrequentFailure/GetFrequentFailures`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina por id la falla frecuente pasada por parámetro
     *
     * @tags RemoveFrequentFailure
     * @name RemoveFrequentFailure
     * @request DELETE:api/v1/FrequentFailure/RemoveFrequentFailure
     * @secure
     */
    RemoveFrequentFailure: (
      frequentFailureId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<RemoveFrequentFailureResponse>
      >({
        url: `/FrequentFailure/${frequentFailureId}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Crea una Falla Frecuente Nueva
     *
     * @tags CreateFrequentFailure
     * @name CreateFrequentFailure
     * @request POST: /api/v1/FrequentFailure
     * @secure
     */
    CreateFrequentFailure: (
      data: CreateDataFreqFailureRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<CreateFreqFailureResponse>>({
        url: `/FrequentFailure`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edita una Falla Frecuente Nueva
     *
     * @tags EditFrequentFailure
     * @name EditFrequentFailure
     * @request PUT: /api/v1/FrequentFailure
     * @secure
     */
    EditFrequentFailure: (
      data: EditFreqFailure,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<EditFrequentFailureResponse>>(
        {
          url: `/FrequentFailure`,
          method: 'PUT',
          data,
          ...config
        }
      )
  },
  FrequentFailureFields: {
    /**
     * Obtiene todos los campos de apertura asociados a un tipo de falla frecuente.
     *
     * @tags FrequentFailureFields
     * @name GetAllFieldsById
     * @request GET /api/v1/FrequentFailureFields/GetAllFields/{id}
     * @secure
     */
    GetAllFieldsById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<FFOpeningFields[]>>({
        url: `/FrequentFailureFields/GetAllFields/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Busca campos de cierre según criterios específicos.

     *
     * @tags FrequentFailureFields
     * @name SearchFields
     * @request GET: api/v1/FrequentFailureFields/SearchFields
     * @secure
     */
    SearchFields: (params: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<FrequentFailure[]>>({
        url: `/FrequentFailureFields/SearchFields`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Crea un nuevo campo de apertura para un tipo de falla frecuente.
     *
     * @tags FrequentFailureFields
     * @name Create
     * @request POST: /api/v1/FrequentFailureFields
     * @secure
     */
    Create: (data: IFreqFailureFields, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<CreateFreqFailureResponse>>({
        url: `/FrequentFailureFields`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza el ordenamiento de los campos de un tipo de falla frecuente.
     *
     * @tags FrequentFailureFields
     * @name Update
     * @request PUT: /api/v1/FrequentFailureFields
     * @secure
     */
    Update: (data: IFreqFailureFields, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<EditFrequentFailureResponse>>(
        {
          url: `/FrequentFailureFields`,
          method: 'PUT',
          data,
          ...config
        }
      ),
    /**
     * Elimina uno o varios campos por su ID, según el tipo de falla frecuente.
     *
     * @tags FrequentFailureFields
     * @name Delete
     * @request DELETE: /api/v1/FrequentFailureFields
     * @secure
     */
    Delete: (
      data: FreqFailureFieldsToDelete,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<RemoveFrequentFailureResponse>
      >({
        url: `/FrequentFailureFields`,
        method: 'DELETE',
        data,
        ...config
      })
  },
  cancelationReason: {
    /**
     * Trae las cancelationReason
     * @tags getAll
     * @name getAll
     * @request GET:api/v1/CancelationReason/GetAll
     * @secure
     */
    getAll: (
      params: { pendingReasonRootId?: number } = {},
      config: AxiosRequestConfig = {}
    ) => {
      const { pendingReasonRootId } = params;
      return instance.request<void, AxiosServiceResponse<CancelationReason[]>>({
        url: `/CancelationReason/GetAll`,
        method: 'GET',
        params: { pendingReasonRootId },
        ...config
      });
    }
  },
  jobSubCategories: {
    /**
     * No description
     *
     * @tags JobSubCategories
     * @name JobSubCategoriesIdDetail
     * @request GET:/api/v1/JobSubCategories/{id}
     * @secure
     */
    jobCategoryIdDetail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<JobSubCategories[]>>({
        url: `/JobSubCategories/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Trae las jobSubCategories
     *
     * @tags GetJobSubCategories
     * @name GetJobSubCategories
     * @request GET:api/v1/JobSubCategories/GetJobSubCategories
     * @secure
     */
    GetJobSubCategories: (
      data: IJobSubCategoryParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ServiceNameResponse>>
      >({
        url: `/JobSubCategories/GetJobSubCategories`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea un tipo de servicio
     *
     * @tags JobSubCategories
     * @name CreateJobSubCategory
     * @request GET:/api/v1/JobSubCategories/CreateJobSubCategory
     * @secure
     */
    CreateJobSubCategory: (
      data: CreateJobSubCategoryItem,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<CreateJobSubCategoryItem>>({
        url: `/JobSubCategories`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edita un tipo de servicio
     *
     * @tags JobSubCategories
     * @name EditJobCategory
     * @request GET:/api/v1/JobSubCategories/EditJobSubCategory
     * @secure
     */
    EditJobSubCategory: (
      data: EditJobSubCategoryItem,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<EditJobSubCategoryItem>>({
        url: `/JobSubCategories`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Elimina por id tipo de servicio
     *
     * @tags RemoveJobSubCategory
     * @name RemoveJobSubCategory
     * @request PUT:api/v1/JobSubCategories/RemoveJobSubCategory
     * @secure
     */
    RemoveJobSubCategory: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<RemoveJobSubCategoryResponse>
      >({
        url: `/JobSubCategories/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  serviceTypes: {
    /**
     * No description
     *
     * @tags serviceTypes
     * @name list
     * @request GET:/api/v1/ServiceTypes
     * @secure
     */
    list: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceType[]>>({
        url: `/ServiceTypes`,
        method: 'GET',
        ...config
      }),

    /**
     * No description
     *
     * @tags serviceTypes
     * @name detail
     * @request GET:/api/v1/ServiceTypes/{id}
     * @secure
     */
    detail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, any>({
        url: `/ServiceTypes/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtener todos los tipos de servicio por clientID
     *
     * @tags serviceTypes
     * @name GetAllServiceTypesByClientID
     * @request GET:/api/v1/ServiceTypes
     * @secure
     */
    GetAllServiceTypesByClientID: (
      id: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceType[]>>({
        url: `/ServiceTypes?clientId=${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtener todos los tipos de servicio
     *
     * @tags serviceTypes
     * @name GetAllServiceTypes
     * @request GET:/api/v1/ServiceTypes
     * @secure
     */
    GetAllServiceTypes: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceType[]>>({
        url: `/ServiceTypes`,
        method: 'GET',
        ...config
      }),

    /**
     * Pide una lista de tipos de servicio
     *
     * @tags serviceTypes
     * @name GetServiceTypes
     * @request POST:/api/v1/ServiceTypes/GetServiceTypes
     * @secure
     */
    GetServiceTypes: (
      data?: ServiceTypesQueryParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<ServiceType>>>({
        url: `/ServiceTypes/GetServiceTypes`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Pide una lista de tipos de servicio
     *
     * @tags serviceTypes
     * @name GetServiceTypesByService
     * @request GET:/api/v1/ServiceTypes/GetServiceTypesByService
     * @secure
     */
    GetServiceTypesByService: (
      params: ServiceTypesQueryParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ServiceTypeByServiceName>>
      >({
        url: `/ServiceTypes/GetServiceTypesByService`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Crea un tipo de servicio
     *
     * @tags serviceTypes
     * @name CreateServiceType
     * @request POST:/api/v1/ServiceTypes
     * @secure
     */
    CreateServiceType: (data: ServiceType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceType>>({
        url: `/ServiceTypes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edita un tipo de servicio
     *
     * @tags serviceType
     * @name UpdateServiceType
     * @request PUT:/api/v1/ServiceTypes
     * @secure
     */
    UpdateServiceType: (data: ServiceType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceType>>({
        url: `/ServiceTypes`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Remueve un tipo de servicio por su id
     *
     * @tags serviceType
     * @name DeleteServiceType
     * @request DELETE:/api/v1/ServiceTypes/{id}
     * @secure
     */
    DeleteServiceType: (
      serviceTypeId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<string>>({
        url: `/ServiceTypes/${serviceTypeId}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Obtiene todos los tipos relacionados según el tipo de servicio.
     *
     * @tags serviceType
     * @name ObtainRelatebleServiceTypesByOtherService
     * @request GET:/api/v1/ServiceTypes/GetAvailableTypes/{id}
     * @secure
     */
    ObtainRelatebleServiceTypesByOtherService: (
      serviceTypeId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<ObtainRelatebleServiceTypesByOtherService[]>
      >({
        url: `/ServiceTypes/GetAvailableTypes/${serviceTypeId}`,
        method: 'GET',
        ...config
      }),
    /**
     * Guarda una encuesta para un tipo de servicio.
     *
     * @tags serviceType
     * @name saveSurveyOfServiceType
     * @request GET:/api/v1/ServiceTypes/{IdServiceType}/Survey/{IdSurvey}
     * @secure
     */
    saveSurveyOfServiceType: (
      IdServiceType: number,
      IdSurvey: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<ObtainRelatebleServiceTypesByOtherService[]>
      >({
        url: `/ServiceTypes/${IdServiceType}/Survey/${IdSurvey}`,
        method: 'PUT',
        ...config
      })
  },
  serviceTypeClosingFields: {
    /**
     * Crea los campos de cierre de un tipo de servicio
     *
     * @tags ServiceTypeClosingFields
     * @name CreateClosingFields
     * @request POST: /api/v1/ServiceTypeClosingFields
     * @secure
     */
    CreateClosingFields: (
      data: ServiceTypeClosingFieldsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<ServiceTypeClosingFieldsRequest>
      >({
        url: `/ServiceTypeClosingFields`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Obtiene los campo de cierres por el id de un tipo de servicio
     *
     * @tags ServiceTypeClosingFields
     * @name ObtainClosingFieldsById
     * @request GET: /api/v1/ServiceTypeClosingFields/GetAllFields/
     * @secure
     */
    ObtainClosingFieldsById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<GetServiceTypeClosingFieldsResponse[]>
      >({
        url: `/ServiceTypeClosingFields/GetAllFields/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Edita el Ordenamiento de los campos de cierre de un tipo de servicio
     *
     * @tags ServiceTypeClosingFields
     * @name EditeClosingFields
     * @request PUT: /api/v1/ServiceTypeClosingFields
     * @secure
     */
    EditeClosingFields: (
      data: ServiceTypeClosingFieldsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<GetServiceTypeClosingFieldsResponse[]>
      >({
        url: `/ServiceTypeClosingFields`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Elimina los campos de cierre de un tipo de servicio
     *
     * @tags ServiceTypeClosingFields
     * @name DeleteClosingFields
     * @request DELETE: /api/v1/ServiceTypeClosingFields
     * @secure
     */
    DeleteClosingFields: (
      data: ServiceTypeClosingFieldsRequestDelete,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<GetServiceTypeClosingFieldsResponse[]>
      >({
        url: `/ServiceTypeClosingFields`,
        method: 'DELETE',
        data,
        ...config
      })
  },
  priorities: {
    /**
     * Obtiene todas las prioridades sin paginación
     *
     * @tags Priorities
     * @name GetAllPriorities
     * @request GET:/api/v1/Priorities
     * @secure
     */
    GetAllPriorities: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PriorityItem[]>>({
        url: `/Priorities`,
        method: 'GET',
        ...config
      }),
    /**
     * Pide una lista de prioridades
     *
     * @tags Priorities
     * @name GetPriorities
     * @request POST:/api/v1/Priorities/GeneralSearch
     * @secure
     */
    GetPriorities: (
      data: PriorityQueryParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<PriorityItem>>>({
        url: `/Priorities/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea una prioridad
     *
     * @tags Priorities
     * @name CreatePriority
     * @request POST:/api/v1/Priority
     * @secure
     */
    CreatePriority: ({ name }: PriorityItem, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceType>>({
        url: `/Priorities`,
        method: 'POST',
        data: { name },
        ...config
      }),
    /**
     * Edita una prioridad
     *
     * @tags Priorities
     * @name EditPriority
     * @request PUT:/api/v1/Priorities
     * @secure
     */
    EditPriority: (
      { id, name, enabled }: PriorityItem,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PriorityItem>>({
        url: `/Priorities`,
        method: 'PUT',
        data: { id, name, enabled },
        ...config
      }),
    /**
     * Remueve un tipo de servicio por su id
     *
     * @tags Priorities
     * @name RemovePriority
     * @request DELETE:/api/v1/Priorities
     * @secure
     */
    RemovePriority: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<string>>({
        url: `/Priorities/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * trae los tipos de prioridades por el id de la prioridad
     *
     * @tags Priorities
     * @name PrioritiTypes
     * @request GET:/api/v1/Priorities
     * @secure
     */
    PrioritiTypes: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PrioritiesTypes[]>>({
        url: `/PriorityTypes/${id}/Priorities`,
        method: 'GET',
        ...config
      })
  },
  models: {
    /**
     * Pide una lista de modelos
     *
     * @tags ProductModel
     * @name GetModels
     * @request GET:/api/v1/ProductModel
     * @secure
     */
    GetModels: (params: ModelQueryParams, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<ModelGetResponse>>>(
        {
          url: `/ProductModel/`,
          method: 'GET',
          params,
          paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: 'repeat' }),
          ...config
        }
      ),
    /**
     * Crea un modelo
     *
     * @tags ProductModel
     * @name CreateModel
     * @request POST:/api/v1/ProductModel
     * @secure
     */
    CreateModel: (data: ModelItem, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ModelItem>>({
        url: `/ProductModel`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edita un modelo
     *
     * @tags Models
     * @name EditModel
     * @request PUT:/api/v1/ProductModel
     * @secure
     */
    EditModel: (data: ModelItem, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ModelItem>>({
        url: `/ProductModel`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Remueve un tipo de servicio por su id
     *
     * @tags Models
     * @name RemoveModel
     * @request DELETE:/api/v1/ProductModel/{id}
     * @secure
     */
    RemoveModel: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<string>>({
        url: `/ProductModel/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Getall de models
     * @tags Models
     * @name GetAllModels
     * @request GET:/api/v1/ProductModel/GetAllProductModels
     * @secure
     */
    GetAllModels: (
      params: { productBrandId?: number } = {},
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<GetAllModelsResponse[]>>({
        url: `/ProductModel/GetAllProductModels`,
        method: 'GET',
        params,
        ...config
      })
  },
  equipmentType: {
    /**
     *
     * GENERAL SEARCH DE TIPO DE EQUIPOS
     *
     * @tags EquipmentType
     * @name generalSearch
     * @request POST: /api/v1/EquipmentType/SearchEquipmentType
     * @secure
     */
    generalSearch: (data: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<PriorityItem[]>>>({
        url: `/EquipmentType/SearchEquipmentType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * GET ALL DE TIPO DE EQUIPOS
     *
     * @tags EquipmentType
     * @name list
     * @request GET:/api/v1/EquipmentType
     * @secure
     */
    list: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PriorityItem[]>>({
        url: `/EquipmentType`,
        method: 'GET',
        ...config
      }),
    /**
     * CREATE DE TIPO DE EQUIPOS
     *
     * @tags EquipmentType
     * @name create
     * @request POST:/api/v1/EquipmentType
     * @secure
     */
    create: (data: { name: string }, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown[]>>({
        url: `/EquipmentType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDIT DE TIPO DE EQUIPOS
     *
     * @tags EquipmentType
     * @name update
     * @request PUT:/api/v1/EquipmentType
     * @secure
     */
    update: (data: EditEquipmentType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown[]>>({
        url: `/EquipmentType`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * DELETE DE TIPO DE EQUIPOS
     *
     * @tags EquipmentType
     * @name delete
     * @request DELETE:/api/v1/EquipmentType
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown[]>>({
        url: `/EquipmentType/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  reparationType: {
    /**
     *
     * GENERAL SEARCH DE TIPO DE EQUIPOS
     *
     * @tags ReparationType
     * @name generalSearch
     * @request POST: /api/v1/ReparationType/SearchAreas
     * @secure
     */
    generalSearch: (data: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<PriorityItem[]>>>({
        url: `/ReparationType/SearchReparationType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * GET ALL DE TIPO DE EQUIPOS
     *
     * @tags ReparationType
     * @name list
     * @request GET:/api/v1/ReparationType
     * @secure
     */
    list: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PriorityItem[]>>({
        url: `/ReparationType`,
        method: 'GET',
        ...config
      }),
    /**
     * CREATE DE TIPO DE EQUIPOS
     *
     * @tags ReparationType
     * @name create
     * @request POST:/api/v1/ReparationType
     * @secure
     */
    create: (data: CreateReparationType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown[]>>({
        url: `/ReparationType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDIT DE TIPO DE EQUIPOS
     *
     * @tags ReparationType
     * @name update
     * @request PUT:/api/v1/ReparationType
     * @secure
     */
    update: (data: EditReparationType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown[]>>({
        url: `/ReparationType`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * DELETE DE TIPO DE EQUIPOS
     *
     * @tags ReparationType
     * @name delete
     * @request DELETE:/api/v1/ReparationType
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown[]>>({
        url: `/ReparationType/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * GET ALL DE TIPO DE EQUIPOS
     *
     * @tags ReparationType
     * @name getReparationTypesByModelId
     * @request GET:/api/v1/ReparationType/Model
     * @secure
     */
    getReparationTypesByModelId: (
      modelId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PriorityItem[]>>({
        url: `/ReparationType/Model/${modelId}`,
        method: 'GET',
        ...config
      })
  },
  origen: {
    /**
     * No description
     *
     * @tags Origen
     * @name getByReasonType
     * @request GET:/api/v1/Origen/getByReasonType/{id}
     * @secure
     */
    getByReasonType: (reasonId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Origin[]>>({
        url: `/Origen/getByReasonType/${reasonId}`,
        method: 'GET',
        ...config
      })
  },
  paymentTypes: {
    /**
     * No description
     *
     * @tags PaymentTypes
     * @name List
     * @request GET:/api/v1/PaymentTypes
     * @secure
     */
    list: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ICatalogEntity[]>>({
        url: `/PaymentTypes`,
        method: 'GET',
        ...config
      }),

    /**
     * No description
     *
     * @tags PaymentTypes
     * @name Detail
     * @request GET:/api/v1/PaymentTypes/{id}
     * @secure
     */
    detail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ICatalogEntity[]>>({
        url: `/PaymentTypes/${id}`,
        method: 'GET',
        ...config
      })
  },
  reasons: {
    /**
     * TRAE TODOS LOS REASONS
     *
     * @tags Reasons
     * @name list
     * @request GET:/api/v1/Reasons
     * @secure
     */
    list: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AceptRejectDetailData[]>>({
        url: `/Reasons`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE LOS REASONS POR ID ESPECIFICO
     *
     * @tags Reasons
     * @name detail
     * @request GET:/api/v1/Reasons/{id}
     * @secure
     */
    detail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AceptRejectDetailData>>({
        url: `/Reasons/${id}`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE LOS REASONS POR TIPO DE RAZON (QUE SIEMPRE ES 1 )
     *
     * @tags Reasons
     * @name getByReasonTypeDetail
     * @request GET:/api/v1/Reasons/getByReasonType/{reasonType}
     * @secure
     */
    getByReasonTypeDetail: (
      reasonType: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ReasonType[]>>({
        url: `/Reasons/getByReasonType/${reasonType}`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * @tags Reasons
     * @name getReasonsByFilter
     * @request POST:/api/v1/Reasons/GetReasons
     * @secure
     */
    getReasonsByFilter: (
      data: IReasonByFilterRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<IReasonByFilterResponse>>
      >({
        url: `/Reasons/GetReasons`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags Reasons
     * @name CreateReason
     * @request POST:/api/v1/Reasons
     * @secure
     */
    createReason: (
      data: ICreateReasonRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ICreateReasonRequest>>({
        url: `/Reasons`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags Reasons
     * @name EditReason
     * @request PUT:/api/v1/Reasons
     * @secure
     */
    editReason: (data: IEditReasonRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IEditReasonRequest>>({
        url: `/Reasons`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags Reasons
     * @name RemoveReason
     * @request PUT:/api/v1/Reasons/{id}
     * @secure
     */
    removeReason: (
      reason: IRemoveReasonRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<IRemoveReasonRequest>>({
        url: `/Reasons/${reason?.id}`,
        method: 'DELETE',
        ...config
      })
  },
  reasonsTypes: {
    /**
     * Retorna todos los tipos de motivos activos.
     *
     * @tags ReasonType
     * @name getAll
     * @request GET:/api/v1/ReasonType/GetAllReasonTypes
     * @secure
     */
    getAll: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ReasonType[]>>({
        url: `/ReasonType/GetAllReasonTypes`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * @tags ReasonType
     * @name getByFilter
     * @request GET:/api/v1/ReasonType
     * @secure
     */
    getByFilter: (
      data: IReasonByFilterRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<ReasonType>>>({
        url: `/ReasonType/SearchReasonType`,
        method: 'GET',
        data,
        ...config
      }),
    /**
     * Crea un nuevo tipo de razón.
     * @tags ReasonType
     * @name create
     * @request POST:/api/v1/ReasonType
     * @secure
     */
    create: (data: ReasonType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ReasonType>>({
        url: `/ReasonType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza un tipo de razón existente.
     * @tags ReasonType
     * @name update
     * @request PUT:/api/v1/ReasonType
     * @secure
     */
    update: (data: ReasonType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IEditReasonRequest>>({
        url: `/ReasonType`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags ReasonType
     * @name delete
     * @request DELETE:/api/v1/ReasonType/{id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IRemoveReasonRequest>>({
        url: `/ReasonType/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  TaskForces: {
    /**
     * @tags catalog
     * @name list
     * @request GET: /api/v1/TaskForce/getAssignableTaskForceByProjectId
     * @secure
     */
    list: (
      params: { projectId: number; name?: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<getAssignableTaskForceByProject[]>
      >({
        url: `/TaskForce/getAssignableTaskForceByProjectId`,
        method: 'GET',
        ...config,
        params
      })
  },
  operationTypes: {
    /**
     * TRAE LOS TIPOS DE SERVICIOS PARA EL COMPONENTE DE CONFIGURACION
     *
     * @tags catalog
     * @name OperationType
     * @request GET: api/v1/OperationType
     * @secure
     */
    OperationType: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<OperationTypeResponse[]>>({
        url: `OperationType`,
        method: 'GET',
        ...config
      })
  },
  inventory: {
    /**
     * Obtiene todos los proveedores de mensajería
     *
     * @tags catalog
     * @name getCouriers
     * @request GET: /api/v1/Inventory/getCouriers
     * @secure
     */
    getCouriers: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<CouriersOption[]>>({
        url: `/Inventory/getCouriers`,
        method: 'GET',
        ...config
      }),

    /**
     * Obtiene todas las prioridades que puede tener un envío
     *
     * @tags catalog
     * @name getShipmentPriority
     * @request GET: /api/v1/Inventory/getShipmentPriority
     * @secure
     */
    getShipmentPriority: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ShipmentPriorityOption[]>>({
        url: `/Inventory/getShipmentPriority`,
        method: 'GET',
        ...config
      }),

    /**
     * Obtiene todos los tipos de destinatario
     *
     * @tags catalog
     * @name getAllResponsibleType
     * @request GET: /api/v1/Inventory/getAllResponsibleType
     * @secure
     */
    getAllResponsibleType: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ResponsibleType[]>>({
        url: `/Inventory/getAllResponsibleType`,
        method: 'GET',
        ...config
      }),

    /**
     * Obtiene un tipo de destinatario
     *
     * @tags catalog
     * @name getResponsibleTypeById
     * @request GET: /api/v1/Inventory/getResponsibleTypeById
     * @secure
     */
    getResponsibleTypeById: (
      params: { id: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ResponsibleType>>({
        url: `/Inventory/getResponsibleTypeById`,
        method: 'GET',
        ...config,
        params
      }),

    /**
     * Obtiene todas los estados de un envío
     *
     * @tags catalog
     * @name getShipmentState
     * @request GET:/api/v1/ShipmentState
     * @secure
     */
    getShipmentState: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ShipmentStateOption[]>>({
        url: `/ShipmentState`,
        method: 'GET',
        ...config
      })
  },
  brands: {
    /**
     * Es el generalSearch pero de Marcas
     *
     * @tags Brands
     * @name GetAllBrands
     * @request POST: api/v1/Brands/SearchBrands
     * @secure
     */
    GetAllBrands: (data: BrandQueryParams, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchBrandsResponse>>
      >({
        url: `/Brands/SearchBrands`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Elimina por id la Marca pasada por parámetro
     *
     * @tags RemoveBrand
     * @name RemoveBrand
     * @request DELETE: api/v1/Brands/{id}
     * @secure
     */
    RemoveBrand: (brandId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<RemoveBrandResponse>>({
        url: `/Brands/${brandId}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Es el generalSearch pero de Marcas
     *
     * @tags Brands
     * @name CreateBrand
     * @request POST: api/v1/Brands
     * @secure
     */
    CreateBrand: (data: CreateBrandRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<CreateBrandResponse>>({
        url: `/Brands`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Es el Edit de Marcas
     *
     * @tags Brands
     * @name EditBrand
     * @request PUT: api/v1/Brands
     * @secure
     */
    EditBrand: (data: EditBrandsResponse, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<CreateBrandResponse>>({
        url: `/Brands`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Listado completo de marcas
     *
     * @tags Brands
     * @name ListBrands
     * @request GET: api/v1/Brands
     * @secure
     */
    ListBrands: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchBrandsResponse[]>>({
        url: `/Brands`,
        method: 'GET',
        ...config
      }),
    /**
     * Pide una lista de modelos por id de marca
     * @tags Brands
     * @name GetModelsByBrandId
     * @request GET:/api/v1/Brands/{id}/ProductModel
     * @secure
     */
    GetModelsByBrandId: (
      id: number,
      clientId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ModelSearchedByBrand[]>>({
        url: `/Brands/${id}/ProductModel?clientId=${clientId}`,
        method: 'GET',
        ...config
      }),

    /**
     * Pide una lista de marcas por pais del cliente
     * @tags Brands
     * @name GetModelsByBrandId
     * @request GET:/api/v1/Brands/{id}/Client
     * @secure
     */
    GetBrandsByClientId: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ModelSearchedByBrand[]>>({
        url: `/Brands/${id}/Client`,
        method: 'GET',
        ...config
      })
  },
  ticketCommentTypes: {
    /**
     *
     * @tags TicketCommentTypes
     * @name getAllCommentTypes
     * @request GET:/api/v1/TicketCommentTypes
     * @secure
     */
    getAllCommentTypes: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AceptRejectDetailData[]>>({
        url: `/TicketCommentTypes`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * @tags TicketCommentTypes
     * @name commentTypeById
     * @request GET:/api/v1/TicketCommentTypes/{id}
     * @secure
     */
    commentTypeById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AceptRejectDetailData>>({
        url: `/TicketCommentTypes/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * @tags TicketCommentTypes
     * @name getCommentTypesByFilter
     * @request POST:/api/v1/TicketCommentTypes/GeneralSearch
     * @secure
     */
    getCommentTypesByFilter: (
      data: ICommentTypesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<PriorityItem>>>({
        url: `/TicketCommentTypes/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags TicketCommentTypes
     * @name createCommentType
     * @request POST:/api/v1/TicketCommentTypes
     * @secure
     */
    createCommentType: (
      data: CreateBrandRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<CreateBrandRequest>>({
        url: `/TicketCommentTypes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags TicketCommentTypes
     * @name editCommentType
     * @request PUT:/api/v1/TicketCommentTypes
     * @secure
     */
    editCommentType: (data: PriorityItem, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PriorityItem>>({
        url: `/TicketCommentTypes`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags TicketCommentTypes
     * @name removeCommentType
     * @request PUT:/api/v1/TicketCommentTypes/{id}
     * @secure
     */
    removeCommentType: (
      reason: IRemoveReasonRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<IRemoveReasonRequest>>({
        url: `/TicketCommentTypes/${reason?.id}`,
        method: 'DELETE',
        ...config
      })
  },
  site: {
    /**
     *
     * @tags Site
     * @name getAllSite
     * @request GET:/api/v1/Site
     * @secure
     */
    getAllSite: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchSiteResponse[]>>({
        url: `/Site`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * @tags Site
     * @name siteById
     * @request GET:/api/v1/Site/{id}
     * @secure
     */
    siteById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AceptRejectDetailData>>({
        url: `/Site/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * @tags Site
     * @name searchSite
     * @request POST:/api/v1/Site/SearchSite
     * @secure
     */
    searchSite: (
      params: ICommentTypesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchSiteResponse>>
      >({
        url: `/Site/SearchSite`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags Site
     * @name createSite
     * @request POST:/api/v1/Site
     * @secure
     */
    createSite: (data: CreateBrandRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<CreateBrandRequest>>({
        url: `/Site`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags Site
     * @name editSite
     * @request PUT:/api/v1/Site
     * @secure
     */
    editSite: (data: IEditSite, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PriorityItem>>({
        url: `/Site`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags Site
     * @name removeSite
     * @request PUT:/api/v1/Site/{id}
     * @secure
     */
    removeSite: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IRemoveReasonRequest>>({
        url: `/Site/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  area: {
    /**
     * TRAE TODAS LAS AREAS CON PAGINADO
     * @tags Area
     * @name GetAllAreasSearch
     * @request POST:/api/v1/Area/SearchAreas
     * @secure
     */
    GetAllAreasSearch: (data: SearchArea, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchAreaResponse>>
      >({
        url: `/Area/SearchAreas`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * TRAE TODAS LAS AREAS SIN PAGINADO
     * @tags Area
     * @name GetAllAreas
     * @request GET:/api/v1/Area
     * @secure
     */
    GetAllAreas: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchAreaResponse[]>>({
        url: `/Area`,
        method: 'GET',
        ...config
      }),
    /**
     * CREA LAS AREAS
     * @tags Area
     * @name CreateNewArea
     * @request POST:/api/v1/Area
     * @secure
     */
    CreateNewArea: (data: string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Area`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EIDTA EL AREA
     * @tags Area
     * @name EditArea
     * @request PUT:/api/v1/Area
     * @secure
     */
    EditArea: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Area`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA EL AREA POR ID
     * @tags Area
     * @name DeleteArea
     * @request DELETE:/api/v1/Area
     * @secure
     */
    DeleteArea: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Area/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  ticketDelayClassification: {
    /**
     * TRAE TODAS LAS CLASIFICACIONES DE DEMORA DE TICKET
     * @tags Clasificaciones de demora de ticket
     * @name GetAllDelayClassifications
     * @request POST:/api/v1/TicketDelayClassification
     * @secure
     */
    GetAllDelayClassifications: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketDelayClassification`,
        method: 'GET',
        ...config
      }),
    /**
     * TRAE TODAS LAS CLASIFICACIONES DE DEMORA DE TICKET CON PAGINADO
     * @tags Clasificaciones de demora de ticket
     * @name GetSearchDelayClassifications
     * @request POST:/api/v1/TicketDelayClassification/SearchDelayClassifications
     * @secure
     */
    GetSearchDelayClassifications: (
      params: SearchArea,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchAreaResponse>>
      >({
        url: `/TicketDelayClassification/SearchDelayClassifications`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * CREA LAS CLASIFICACIONES DE DEMORA DE TICKET
     * @tags Clasificaciones de demora de ticket
     * @name CreateDelayClassifications
     * @request POST:/api/v1/TicketDelayClassification
     * @secure
     */
    CreateDelayClassifications: (
      data: string,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketDelayClassification`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDITA LA CLASIFICACION DE DEMORA DE TICKET
     * @tags Clasificaciones de demora de ticket
     * @name EditDelayClassifications
     * @request PUT:/api/v1/Area
     * @secure
     */
    EditDelayClassifications: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketDelayClassification`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA LA CLASIFICACION DE DEMORA DE TICKET POR ID
     * @tags Clasificaciones de demora de ticket
     * @name DeleteDelayClassifications
     * @request DELETE:/api/v1/TicketDelayClassification/{id}
     * @secure
     */
    DeleteDelayClassifications: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketDelayClassification/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  impact: {
    /**
     * TRAE TODAS LOS IMPACTOS CON PAGINADO
     * @tags impacto
     * @name GetAllImpactsSearch
     * @request GET:/api/v1/Impact/
     * @secure
     */
    GetAllImpactsSearch: (data: SearchArea, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchAreaResponse>>
      >({
        url: `/Impact/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * TRAE TODAS LOS IMPACTOS CONFIGURADOS
     * @tags Impactos configurados
     * @name GetAllImpactConfiguration
     * @request GET:/api/v1/Impact/GetAllConfigured
     * @secure
     */
    GetAllImpactConfiguration: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchAreaResponse[]>>({
        url: `/Impact/GetAllConfigured`,
        method: 'GET',
        ...config
      }),
    /**
     * TRAE TODAS LOS IMPACTOS
     * @tags Impactos
     * @name GetAllImpact
     * @request GET:/api/v1/Impact/GetAll
     * @secure
     */
    GetAllImpact: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchAreaResponse[]>>({
        url: `/Impact/GetAll`,
        method: 'GET',
        ...config
      }),
    /**
     * CREA LOS IMPACTOS
     * @tags Impactos
     * @name CreateNewImpact
     * @request POST:/api/v1/Impact
     * @secure
     */
    CreateNewImpact: (data: string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Impact`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EIDTA LOS IMPACTOS
     * @tags Impactos
     * @name EditImpact
     * @request PUT:/api/v1/Impact
     * @secure
     */
    EditImpact: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Impact`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA EL IMPACTO POR ID
     * @tags Impacto
     * @name DeleteImpact
     * @request DELETE:/api/v1/Impact/${id}
     * @secure
     */
    DeleteImpact: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Impact/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  urgency: {
    /**
     * TRAE TODAS LAS URGENCIAS CON PAGINADO
     * @tags Urgencia
     * @name GetAllUrgencySearch
     * @request GET:/api/v1/Urgency
     * @secure
     */
    GetAllUrgencySearch: (data: SearchArea, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchAreaResponse>>
      >({
        url: `/Urgency/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * TRAE TODAS LAS URGENCIAS CONFIGURADAS
     * @tags Urgencias configurados
     * @name GetAllUrgencyConfiguration
     * @request GET:/api/v1/Urgency/GetAllConfigured
     * @secure
     */
    GetAllUrgencyConfiguration: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchAreaResponse[]>>({
        url: `/Urgency/GetAllConfigured`,
        method: 'GET',
        ...config
      }),
    /**
     * TRAE TODAS LAS URGENCIAS
     * @tags Urgencias
     * @name GetAllUrgency
     * @request GET:/api/v1/Urgency/GetAll
     * @secure
     */
    GetAllUrgency: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchAreaResponse[]>>({
        url: `/Urgency/GetAll`,
        method: 'GET',
        ...config
      }),
    /**
     * CREA LAS URGENCIAS
     * @tags Area
     * @name CreateNewUrgency
     * @request POST:/api/v1/Urgency
     * @secure
     */
    CreateNewUrgency: (data: string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Urgency`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDITA LA URGENCIA
     * @tags Urgencia
     * @name EditUrgency
     * @request PUT:/api/v1/Urgency
     * @secure
     */
    EditUrgency: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Urgency`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA LA URGENCIA POR ID
     * @tags Area
     * @name DeleteUrgency
     * @request DELETE:/api/v1/Urgency/${id}
     * @secure
     */
    DeleteUrgency: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Urgency/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  priority: {
    /**
     * TRAE TODAS LAS PRIORIDADES CON PAGINADO
     * @tags Prioridad
     * @name GetAllPrioritySearch
     * @request GET:/api/v1/TicketPriority/GeneralSearch
     * @secure
     */
    GetAllPrioritySearch: (data: SearchArea, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchAreaResponse>>
      >({
        url: `/TicketPriority/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * TRAE TODAS LAS PRIORIDADES
     * @tags Prioridad
     * @name GetAllPriorities
     * @request GET:/api/v1/TicketPriority/GetAll
     * @secure
     */
    GetAllPriorities: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TicketPriorityResponse[]>>({
        url: `/TicketPriority/GetAll`,
        method: 'GET',
        ...config
      }),
    /**
     * CREA LAS PRIORIDADES
     * @tags Prioridad
     * @name CreateNewPriority
     * @request POST:/api/v1/TicketPriority
     * @secure
     */
    CreateNewPriority: (data: string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketPriority`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDITA LA PRIORIDAD
     * @tags Prioridad
     * @name EditPriority
     * @request PUT:/api/v1/TicketPriority
     * @secure
     */
    EditPriority: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketPriority`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA LA PRIORIDAD POR ID
     * @tags Prioridad
     * @name DeletePriority
     * @request DELETE:/api/v1/TicketPriority/${id}
     * @secure
     */
    DeletePriority: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketPriority/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  criticality: {
    /**
     * TRAE TODAS LAS CRITICIDADES CON PAGINADO
     * @tags Criticidad
     * @name GetAllCriticalitySearch
     * @request GET:/api/v1/AssignmentPriority/GeneralSearch
     * @secure
     */
    GetAllCriticalitySearch: (
      data: SearchArea,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchAreaResponse>>
      >({
        url: `/AssignmentPriority/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * TRAE TODAS LA PRIORIDAD RELACIONADA CON EL IMPACTO Y URGENCIA
     * @tags Prioridad
     * @name GetPriorityByUrgencyAndImpact
     * @request GET:/api/v1/AssignmentPriority/GetPriorityByUrgencyAndImpact
     * @secure
     */
    GetPriorityByUrgencyAndImpact: (
      params: FormCriticality,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<IPriorityByUrgencyAndImpact>>(
        {
          url: `/AssignmentPriority/GetPriorityByUrgencyAndImpact`,
          method: 'GET',
          params,
          ...config
        }
      ),
    /**
     * CREA LAS CRITICIDADES
     * @tags Criticidad
     * @name CreateNewCriticality
     * @request POST:/api/v1/AssignmentPriority
     * @secure
     */
    CreateNewCriticality: (
      data: FormCriticality,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/AssignmentPriority`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDITA LA CRITICIDAD
     * @tags Criticidad
     * @name EditCriticality
     * @request PUT:/api/v1/EditCriticality
     * @secure
     */
    EditCriticality: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/AssignmentPriority`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA LA CRITICIDAD POR ID
     * @tags Criticidad
     * @name DeleteCriticality
     * @request DELETE:/api/v1/AssignmentPriority/${id}
     * @secure
     */
    DeleteCriticality: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/AssignmentPriority/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  generatedReport: {
    /**
     * TRAE TODOS LOS REPORTES GENERADOS CON PAGINADO
     * @tags Reportes Generados
     * @name searchGeneratedReports
     * @request POST:/api/v1/GeneratedReport/SearchGeneratedReports
     * @secure
     */
    searchGeneratedReports: (
      data: SearchGeneratedReportsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<GeneratedReport>>>({
        url: `/GeneratedReport/SearchGeneratedReports`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * TRAE TODOS LOS TIPOS DE REPORTES GENERADOS SIN PAGINADO
     * @tags Reportes Generados
     * @name getGeneratedReportTypes
     * @request GET:/api/v1/GeneratedReport/GetGeneratedReportTypes
     * @secure
     */
    getGeneratedReportTypes: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<string[]>>({
        url: `/GeneratedReport/GetGeneratedReportTypes`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE TODOS LOS TIPOS DE REPORTES GENERADOS SIN PAGINADO
     * @tags Reportes Generados
     * @name getGeneratedReportStatus
     * @request GET:/api/v1/GeneratedReport/GetGeneratedReportStatus
     * @secure
     */
    getGeneratedReportStatus: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<string[]>>({
        url: `/GeneratedReport/GetGeneratedReportStatus`,
        method: 'GET',
        ...config
      }),

    /**
     * Genera mensaje de error en el reporte generado
     * @tags Reportes Generados
     * @name SaveReportWithError
     * @request POST:/api/v1/GeneratedReport/SaveReportWithError
     */
    saveReportWithError: (
      data: SaveReportWithErrorRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/GeneratedReport/SaveReportWithError`,
        method: 'POST',
        data,
        ...config
      })
  },
  statusCongurationComponents: {
    /**
     * TRAE TODAS LOS ESTATUS DE COMPONENT DE CONFIGURACIÓN CON PAGINADO
     * @tags estatus de componente de configuración
     * @name GetAllAreasSearch
     * @request POST:/api/v1/ProductStatus/SearchProductStatus
     * @secure
     */
    SearchProductStatus: (params: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<ProductStatus[]>>>({
        url: `/ProductStatus/SearchProductStatus`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * TRAE TODOS LOS ESTATUS DE COMPONENT DE CONFIGURACIÓN SIN PAGINADO
     * @tags estatus de componente de configuración
     * @name ProductAllStatus
     * @request GET:/api/v1/ProductStatus
     * @secure
     */
    ProductAllStatus: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ProductStatus[]>>({
        url: `/ProductStatus`,
        method: 'GET',
        ...config
      }),
    /**
     * CREA ESTATUS DE COMPONENT DE CONFIGURACIÓN
     * @tags estatus de componente de configuración
     * @name CreateNewProductStatus
     * @request POST:/api/v1/ProductStatus
     * @secure
     */
    CreateNewProductStatus: (data: string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ProductStatus`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDITAR ESTATUS DE COMPONENT DE CONFIGURACIÓN
     * @tags estatus de componente de configuración
     * @name EditProductStatus
     * @request PUT:/api/v1/ProductStatus
     * @secure
     */
    EditProductStatus: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ProductStatus`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA ESTATUS DE COMPONENT DE CONFIGURACIÓN POR ID
     * @tags estatus de componente de configuración
     * @name DeleteProductStatus
     * @request DELETE:/api/v1/ProductStatus/{id}
     * @secure
     */
    DeleteProductStatus: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ProductStatus/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  areaManager: {
    /**
     * TRAE TODAS LOS JEFES AREAS CON PAGINADO
     * @tags Jefes de Area
     * @name GetAllAreasManagerSearch
     * @request POST:/api/v1/AreaManager/SearchAreaManagers
     * @secure
     */
    GetAllAreasManagerSearch: (
      data: SearchAreaManager,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchAreaManagerResponse>>
      >({
        url: `/AreaManager/SearchAreaManagers`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * TRAE TODOS LOS JEFES AREAS SIN PAGINADO
     * @tags Jefes de Area
     * @name GetAllAreasManager
     * @request GET:/api/v1/AreaManager
     * @secure
     */
    GetAllAreasManager: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchAreaManagerResponse[]>>(
        {
          url: `/AreaManager`,
          method: 'GET',
          ...config
        }
      ),
    /**
     * CREA LOS JEFES DE AREAS
     * @tags Jefes de Area
     * @name CreateNewAreaManager
     * @request POST:/api/v1/Area
     * @secure
     */
    CreateNewAreaManager: (
      data: SaveAreaManager,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/AreaManager`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDITA LOS JEFES DE AREA
     * @tags Jefes de Area
     * @name EditAreaManager
     * @request PUT:/api/v1/AreaManager
     * @secure
     */
    EditAreaManager: (data: EditAreaManager, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/AreaManager`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * BORRA LOS JEFES DE AREA POR ID
     * @tags Area
     * @name DeleteAreaManager
     * @request DELETE:/api/v1/AreaManager/{id}
     * @secure
     */
    DeleteAreaManager: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/AreaManager/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  clientClassification: {
    /**
     * @tags ClientClassification
     * @name GetAllClientClassification
     * @request GET:/api/v1/ClientClassification
     * @secure
     */
    GetAllClientClassification: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ClientClassification[]>>({
        url: `/ClientClassification`,
        method: 'GET',
        ...config
      })
  },
  projects: {
    /**
     * @tags CatalogProjects
     * @name GetAllProjects
     * @request GET:/api/v1/Project/GetProjects
     * @secure
     */
    GetAllProjects: (params: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<ProjectResponse>>>({
        url: `/Project/GetProjects`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags CatalogProjects
     * @name CreateProjects
     * @request POST:/api/v1/Project
     * @secure
     */
    CreateProjects: (data: CreateProject, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Project`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags CatalogProjects
     * @name EditProject
     * @request PUT:/api/v1/Project
     * @secure
     */
    EditProject: (data: EditProject, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Project`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags CatalogProjects
     * @name DeleteProject
     * @request DELETE:/api/v1/Project
     * @secure
     */
    DeleteProject: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Project/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  status: {
    /**
     * TRAE TODOS LOS ESTATUS PAGINADOS
     * @tags CatalogStatus
     * @name GetAllStatusPaginated
     * @request GET:/api/v1/TicketStatus/SearchTicketStatus
     * @secure
     */
    GetAllStatusPaginated: (
      params: IParamsFilter,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<GetAllStatus>>>({
        url: `/TicketStatus/SearchTicketStatus`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * TRAE TODOS LOS ESTATUS POR SU CATEGORYID
     * @tags CatalogStatus
     * @name GetAllTicketStatusByCategory
     * @request GET:/api/v1/TicketStatus
     * @secure
     */
    GetAllTicketStatusByCategory: (
      params: {
        categoryId: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<StatusItem[]>>({
        url: `/TicketStatus/GetAllTicketStatusByCategory`,
        method: 'GET',
        params,
        paramsSerializer: (P) => qs.stringify(P, { arrayFormat: 'repeat' }),
        ...config
      }),
    /**
     * TRAE TODOS LOS ESTATUS
     * @tags CatalogStatus
     * @name GetAllStatus
     * @request GET:/api/v1/TicketStatus
     * @secure
     */
    GetAllStatus: (
      params: {
        onlyEnabled?: boolean;
        clientId?: number;
        serviceTypeId?: number;
        fromTicketFlow?: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<StatusItem[]>>({
        url: `/TicketStatus`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * POST DE CREACION DE CATALOGO
     * @tags CatalogStatus
     * @name CreateNewCatalogStatus
     * @request POST:/api/v1/TicketStatus
     * @secure
     */
    CreateNewCatalogStatus: (
      data: CreateStatusRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/TicketStatus`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * PUT DE EDICION DE CATALOGO
     * @tags CatalogStatus
     * @name EditNewCatalogStatus
     * @request PUT:/api/v1/TicketStatus
     * @secure
     */
    EditNewCatalogStatus: (
      data: EditStatusRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/TicketStatus`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * ELIMINACION DE CATALOGO
     * @tags CatalogStatus
     * @name DeleteCatalogStatus
     * @request DELETE:/api/v1/TicketStatus
     * @secure
     */
    DeleteCatalogStatus: (data: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/TicketStatus/${data}`,
        method: 'DELETE',
        ...config
      })
  },
  ticketStatusCategory: {
    /**
     * @tags TicketStatusCategory
     * @name getAllTicketStatusCategory
     * @request GET:/api/v1/TicketStatusCategory/GetAllTicketStatusCategory
     * @secure
     */
    getAllTicketStatusCategory: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TicketStatus[]>>({
        url: `/TicketStatusCategory/GetAllTicketStatusCategory`,
        method: 'GET',
        ...config
      })
  },
  towerModel: {
    /**
     * @tags TowerModels
     * @name getTowerModels
     * @request GET:/api/v1/TowerModels/ByTowerType/{towerTypeId}
     * @secure
     */
    getTowerModelsById: (
      towerTypeId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<TowerModel[]>>({
        url: `/TowerModels/ByTowerType/${towerTypeId}`,
        method: 'GET',
        ...config
      }),
    /**
     * @tags TowerModels
     * @name createTowerModel
     * @request POST:/api/v1/TowerModels
     * @secure
     */
    createTowerModel: (data: TowerModel, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerModel>>({
        url: `/TowerModels`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags TowerModels
     * @name editTowerModel
     * @request PUT:/api/v1/TowerModels
     * @secure
     */
    editTowerModel: (data: TowerModel, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerModel>>({
        url: `/TowerModels`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags TowerModels
     * @name removeTowerModel
     * @request DELETE:/api/v1/TowerModels/{id}
     * @secure
     */
    removeTowerModel: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerModel>>({
        url: `/TowerModels/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * @tags TowerModels
     * @name generalSearch
     * @request POST:/api/v1/TowerModels/GeneralSearch
     * @secure
     */
    generalSearch: (
      data: TowerModelGeneralSearch,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TowerModel>>>({
        url: `/TowerModels/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      })
  },
  towerType: {
    /**
     * @tags TowerType
     * @name getTowerType
     * @request GET:/api/v1/TowerType
     * @secure
     */
    getTowerType: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerType[]>>({
        url: `/TowerType`,
        method: 'GET',
        ...config
      }),

    /**
     * @tags TowerType
     * @name createTowerType
     * @request POST:/api/v1/TowerType
     * @secure
     * @description Crea un nuevo tipo de torre
     */

    createTowerType: (data: TowerType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerType>>({
        url: `/TowerType`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags TowerType
     * @name editTowerType
     * @request PUT:/api/v1/TowerType
     * @secure
     * @description Edita un tipo de torre
     */
    editTowerType: (data: TowerType, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerType>>({
        url: `/TowerType`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags TowerType
     * @name removeTowerType
     * @request DELETE:/api/v1/TowerType/{id}
     * @secure
     * @description Elimina un tipo de torre
     */
    removeTowerType: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerType>>({
        url: `/TowerType/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * @tags TowerType
     * @name generalSearch
     * @request POST:/api/v1/TowerType/GeneralSearch
     * @secure
     * @description Busca tipos de torre
     */
    generalSearch: (
      data: TowerModelGeneralSearch,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TowerType>>>({
        url: `/TowerType/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      })
  },
  towerProperty: {
    /**
     * @tags TowerProperties
     * @name getTowerProperties
     * @request GET:/api/v1/TowerProperties
     * @secure
     */
    getTowerProperties: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerProperty[]>>({
        url: `/TowerProperties`,
        method: 'GET',
        ...config
      }),

    /**
     * @tags TowerProperties
     * @name createTowerProperties
     * @request POST:/api/v1/TowerProperties
     * @secure
     * @description Crea un nuevo tipo de torre
     */

    createTowerProperties: (
      data: TowerProperty,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<TowerProperty>>({
        url: `/TowerProperties`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags TowerProperties
     * @name editTowerProperties
     * @request PUT:/api/v1/TowerProperties
     * @secure
     * @description Edita un tipo de torre
     */
    editTowerProperties: (
      data: TowerProperty,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<TowerProperty>>({
        url: `/TowerProperties`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags TowerProperties
     * @name removeTowerProperties
     * @request DELETE:/api/v1/TowerProperties/{id}
     * @secure
     * @description Elimina un tipo de torre
     */
    removeTowerProperties: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TowerProperty>>({
        url: `/TowerProperties/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * @tags TowerProperties
     * @name generalSearch
     * @request POST:/api/v1/TowerProperties/GeneralSearch
     * @secure
     * @description Busca tipos de torre
     */
    generalSearch: (
      data: TowerModelGeneralSearch,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TowerProperty>>>({
        url: `/TowerProperties/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      })
  },
  workFlowOrderStates: {
    /**
     * @tags WorkFlowOrderStates
     * @name getWorkFlowOrderStates
     * @request GET /api/v1/WorkFlowOrderStates
     * @secure
     */
    getWorkFlowOrderStates: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<WorkFlowOrderStates[]>>({
        url: `/WorkFlowOrderStates`,
        method: 'GET',
        ...config
      })
  },
  workFlowTypes: {
    /**
     * @tags CatalogWorkFlowTypes
     * @name SearchWorkFlowTypes
     * @request GET:/api/v1/WorkFlowType
     * @secure
     */
    getAllWorkFlowTypes: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<WorkFlowTypeResponse[]>>({
        url: `/WorkFlowType`,
        method: 'GET',
        ...config
      }),
    /**
     * @tags CatalogWorkFlowTypes
     * @name SearchWorkFlowTypes
     * @request POST:/api/v1/WorkFlowType/SearchWorkFlowTypes
     * @secure
     */
    SearchWorkFlowTypes: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<WorkFlowTypeResponse>>
      >({
        url: `/WorkFlowType/SearchWorkFlowTypes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags CatalogWorkFlowTypes
     * @name CreateWorkFlowType
     * @request POST:/api/v1/WorkFlowType
     * @secure
     */
    CreateWorkFlowType: (
      data: CreateWorkFlowType,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/WorkFlowType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags CatalogWorkFlowTypes
     * @name EditWorkFlowType
     * @request PUT:/api/v1/WorkFlowType
     * @secure
     */
    EditWorkFlowType: (
      data: EditWorkFlowType,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/WorkFlowType`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags CatalogWorkFlowTypes
     * @name DeleteWorkFlowType
     * @request DELETE:/api/v1/WorkFlowType
     * @secure
     */
    DeleteWorkFlowType: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/WorkFlowType/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * @tags CatalogWorkFlowTypes
     * @name GetAllWorkFlowTypes
     * @request GET:/api/v1/WorkFlowType
     * @secure
     */
    GetAllWorkFlowTypes: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<WorkFlowTypeResponse[]>>({
        url: `/WorkFlowType`,
        method: 'GET',
        ...config
      }),
    /**
     * @tags CatalogWorkFlowTypes
     * @name GetWorkFlowTypesByClient
     * @request GET:/api/v1/WorkFlowType/Client/{id}
     * @secure
     */

    GetWorkFlowTypesByClient: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<WorkFlowTypeResponse[]>>({
        url: `/WorkFlowType/Client/${id}`,
        method: 'GET',
        ...config
      })
  },
  ResponsibleType: {
    /**
     * @tags ResponsibleType
     * @name getAllResponsibleType
     * @request GET:/api/v1/ResponsibleType/SearchResponsibleType
     * @secure
     */
    getAllResponsibleType: (
      params?: IParamsFilter,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<any[]>>>({
        url: `/ResponsibleType/SearchResponsibleType`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags ResponsibleType
     * @name CreateResponsibleType
     * @request POST:/api/v1/ResponsibleType
     * @secure
     */
    CreateResponsibleType: (data?: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any[]>>({
        url: `/ResponsibleType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags ResponsibleType
     * @name UpdateResponsibleType
     * @request PUT:/api/v1/ResponsibleType
     * @secure
     */
    UpdateResponsibleType: (data?: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any[]>>({
        url: `/ResponsibleType`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags ResponsibleType
     * @name DeleteResponsibleType
     * @request DELETE :/api/v1/ResponsibleType/SearchResponsibleType
     * @secure
     */
    DeleteResponsibleType: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<any[]>>>({
        url: `/ResponsibleType/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * @tags ResponsibleType
     * @name getActiveResponsibleType
     * @request GET :/api/v1/ResponsibleType
     * @secure
     */
    getActiveResponsibleType: (
      params: { onlyEnabled: boolean },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ResponsibleType[]>>({
        url: `/ResponsibleType`,
        method: 'GET',
        params,
        ...config
      })
  },
  productStatus: {
    /**
     * @tags ProductStatus
     * @name getAllProductStatus
     * @request GET:/api/v1/ProductStatus
     * @secure
     */
    getAllProductStatus: (
      params: {
        onlyEnabled: boolean;
        isLab?: boolean;
        responsibleTypeId?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductStatus[]>>({
        url: `/ProductStatus`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags ProductStatus
     * @name getAllProductStatusForCreation
     * @request GET:/api/v1/ProductStatus/ForCreation
     * @secure
     */
    getAllProductStatusForCreation: (
      params: { isForEdition: boolean },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductStatus[]>>({
        url: `/ProductStatus/ForCreation`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * @tags ProductStatus
     * @name getProductMovementStatus
     * @request GET:/api/v1/ProductStatus/ProductMovementStatus
     * @secure
     */
    getProductMovementStatus: (
      productId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductStatus[]>>({
        url: `/ProductStatus/ProductMovementStatus`,
        method: 'GET',
        ...config,
        params: { productId }
      })
  },
  productCondition: {
    /**
     * @tags ProductCondition
     * @name getAllProductCondition
     * @request GET:/api/v1/ProductCondition
     * @secure
     */
    getAllProductCondition: (
      params: { onlyEnabled?: boolean } = {},
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductConditionItem[]>>({
        url: `/ProductCondition`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * @tags ProductCondition
     * @name searchProductConditions
     * @request POST:/api/v1/ProductCondition/SearchProductCondition
     * @secure
     */
    searchProductConditions: (params: any, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ProductConditionItem>>
      >({
        url: `/ProductCondition/SearchProductCondition`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * @tags ProductCondition
     * @name createComponentCondition
     * @request POST:/api/v1/ProductCondition
     * @secure
     */
    createProductCondition: (
      data: CreateProductCondition,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ProductCondition`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags ProductCondition
     * @name editProductCondition
     * @request PUT:/api/v1/ProductCondition
     * @secure
     */
    editProductCondition: (
      data: EditProductCondition,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ProductCondition`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * @tags ProductCondition
     * @name deleteProductCondition
     * @request DELETE:/api/v1/ProductCondition
     * @secure
     */
    deleteProductCondition: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ProductCondition/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * @tags ProductCondition
     * @name getProductConditionByProductStatusId
     * @request GET:/api/v1/ProductCondition/GetProductConditionByProductStatusesId
     * @secure
     */
    getProductConditionByProductStatusId: (
      params: { productStatuses: number[] },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ProductConditionItem[]>>({
        url: `/ProductCondition/GetProductConditionByProductStatusesId`,
        method: 'GET',
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
        ...config
      })
  },
  unitsOfMeasure: {
    /**
     * @tags unitsOfMeasure
     * @name getAllUnitOfMeasure
     * @request GET:/api/v1/UnitMeasurement
     * @secure
     */
    getAllUnitOfMeasure: (config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<UnitsOfMeasurementResponse[]>
      >({
        url: `/UnitMeasurement`,
        method: 'GET',
        ...config
      })
  },
  PendingReason: {
    /**
     * @tags ReasonPendingForReason
     * @name getAllReasonPendingForReason
     * @request GET:/api/v1/PendingReason/GeneralSearch
     * @secure
     */
    getAllReasonPendingForReason: (
      params: IParamsFilter & { pendingReasonRootId?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ReasonReasonPendingForReasonResponse>>
      >({
        url: `/PendingReason/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags PendingReason/GetChildListByRootId
     * @name getAllGetChildListByRootIdById
     * @request GET:/api/v1/PendingReason/GetChildListByRootId/{id}
     * @secure
     */
    getAllGetChildListByRootIdById: (
      id: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ReasonReasonPendingForReasonResponse>>
      >({
        url: `/PendingReason/GetChildListByRootId/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * @tags ReasonPendingForReason
     * @name createReasonPendingForReason
     * @request POST: /api/v1/PendingReason
     * @secure
     */
    createReasonPendingForReason: (
      data: CreateReasonPendingForReasonRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PendingReason`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags ReasonPendingForReason
     * @name editReasonPendingForReason
     * @request PUT: /api/v1/PendingReason
     * @secure
     */
    editReasonPendingForReason: (
      data: CreateReasonPendingForReasonRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PendingReason`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags ReasonPendingForReason
     * @name deleteReasonPendingForReason
     * @request DELETE: /api/v1/PendingReason/{id}
     * @secure
     */
    deleteReasonPendingForReason: (
      id: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PendingReason/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * @tags getAll
     * @name getAll
     * @request GET: /api/v1/PendingReason/GetAll
     * @secure
     */
    getAll: (
      params: { pendingReasonRootId?: number } = {},
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PendingReason[]>>({
        url: `/PendingReason/GetAll`,
        method: 'GET',
        params,
        ...config
      })
  },
  CancellationReason: {
    /**
     * @tags CancellationReason
     * @name getAllCancellationReason
     * @request GET:/CancelationReason/GeneralSearch
     * @secure
     */
    getAllCancellationReason: (
      params: IParamsFilter & { cancelationReasonLevel?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<CancelationReasonResponse>>
      >({
        url: `/CancelationReason/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags CancelationReason/GetChildListByRootId/
     * @name getAllChildrenListFromCancellationReason
     * @request GET:/api/v1/CancelationReason/GeneralSearch
     * @secure
     */
    getAllChildrenListFromCancellationReason: (
      params: {
        cancelationReasonRootId: number;
        enabled?: boolean;
        pageNumber?: number;
        pageSize?: number;
        text?: string;
        isExport?: boolean;
        orderColumn?: string;
        descending?: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ChildCancelationReason>>
      >({
        url: `/CancelationReason/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags CancelationReason
     * @name createCancelationReason
     * @request POST: /api/v1/CancelationReason
     * @secure
     */
    createCancelationReason: (
      data: CreateCancelationReasonResponseRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/CancelationReason`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags CancelationReason
     * @name editCancelationReason
     * @request PUT: /api/v1/CancelationReason
     * @secure
     */
    editCancelationReason: (
      data: CreateCancelationReasonResponseRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/CancelationReason`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags CancelationReason
     * @name deleteCancelationReason
     * @request DELETE: /api/v1/CancelationReason/{id}
     * @secure
     */
    deleteCancelationReason: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/CancelationReason/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * @tags CancelationReason
     * @name getAll
     * @request GET: /api/v1/CancelationReason/GetAll
     * @secure
     */
    getAll: (
      params: { PendingReasonRootId?: number } = {},
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<CancelationReason[]>>({
        url: `/CancelationReason/GetAll`,
        method: 'GET',
        params,
        ...config
      })
  },
  category: {
    /**
     * @tags /Category/GeneralSearch
     * @name getAllChildrenListFromCategory
     * @request GET:/api/v1/Category/GeneralSearch
     * @secure
     */
    getAllChildrenListFromCategory: (
      data: {
        categoryId?: number;
        idCategoryRoot?: number;
        enabled?: boolean;
        pageNumber?: number;
        pageSize?: number;
        text?: string;
        isExport?: boolean;
        orderColumn?: string;
        descending?: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ChildCancelationReason>>
      >({
        url: `/Category/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags GetAllCategory
     * @name getAllCategory
     * @request GET: /api/v1/Category/GetAll
     * @secure
     */
    getAllCategory: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<categoryActive[]>>({
        url: `/Category/GetAll`,
        method: 'GET',
        ...config
      }),
    /**
     * @tags CancelationReason
     * @name getAll
     * @request GET: /api/v1/CancelationReason/GetAll
     * @secure
     */
    getAllSubCategory: (
      params: { idCategoryRoot?: number | string } = {},
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<categoryActive[]>>({
        url: `Category/GetAll`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags createCategory
     * @name createCategory
     * @request POST: /api/v1/Category
     * @secure
     */
    createCategory: (
      data: CreateCancelationReasonResponseRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Category`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags editCategory
     * @name editCategory
     * @request PUT: /api/v1/Category
     * @secure
     */
    editCategory: (
      data: CreateCancelationReasonResponseRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Category`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags deleteCategory
     * @name deleteCategory
     * @request DELETE: /api/v1/Category/{id}
     * @secure
     */
    deleteCategory: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Category/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  interventionCodes: {
    /**
     * @tags interventionCodes
     * @name getAllLevelOneInterventionCodes
     * @request POST:/api/v1/InterventionCodes/GeneralSearch
     * @secure
     */
    getAllLevelOneInterventionCodes: (
      params: IParamsFilter & { interventionCodeRootId?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<InterventionCodesResponse>>
      >({
        url: `/InterventionCodes/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags interventionCodes
     * @name getListByLevel
     * @request POST:/api/v1/InterventionCodes/GetListByLevel
     * @secure
     */
    getListByLevel: (
      data: IParamsFilter & { interventionCodeLevelId?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<InterventionCodesResponse>>
      >({
        url: `/InterventionCodes/GetListByLevel`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags interventionCodes
     * @name getAllInterventionsCodesById
     * @request GET:/api/v1/InterventionCodes/GetChildListByRootId/18
     * @secure
     */
    getAllInterventionsCodesById: (
      id: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<InterventionCodesResponse>>
      >({
        url: `/InterventionCodes/GetChildListByRootId/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * @tags interventionCodes
     * @name createInterventionCodes
     * @request POST: /api/v1/InterventionCodes
     * @secure
     */
    createInterventionCodes: (
      data: CreateInterventionCodesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/InterventionCodes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags interventionCodes
     * @name editInterventionCodes
     * @request PUT: /api/v1/InterventionCodes
     * @secure
     */
    editInterventionCodes: (
      data: CreateInterventionCodesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/InterventionCodes`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags interventionCodes
     * @name deleteInterventionCodes
     * @request DELETE: /api/v1/InterventionCodes
     * @secure
     */
    deleteInterventionCodes: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/InterventionCodes/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  scheduledReason: {
    /**
     * @tags GeneralSearch
     * @name GeneralSearch
     * @request GET: /api/v1/ScheduledReason/GeneralSearch
     * @secure
     */
    generalSearch: (params: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ScheduledReasonResponse>>
      >({
        url: `/ScheduledReason/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags CreateNewScheduledReason
     * @name CreateNewScheduledReason
     * @request POST: /api/v1/ScheduledReason
     * @secure
     */
    createNewSchedueledReason: (
      data: { description: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ScheduledReason`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags EditNewScheduledReason
     * @name EditNewScheduledReason
     * @request PUT: /api/v1/ScheduledReason
     * @secure
     */
    editNewSchedueledReason: (
      data: ScheduledReasonUpdateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ScheduledReason`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags DeleteScheduledReason
     * @name DeleteScheduledReason
     * @request DELETE: api/v1/ScheduledReason/1
     * @secure
     */
    deleteSchedueledReason: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ScheduledReason/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  pendingForSerialReason: {
    /**
     * @tags GeneralSearch
     * @name GeneralSearch
     * @request GET: /api/v1/PendingSerieReason/GeneralSearch
     * @secure
     */
    generalSearch: (params: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<PendingForSerialReason>>
      >({
        url: `/PendingSerieReason/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags CreateNewPendingSerialReason
     * @name CreateNewPendingSerialReason
     * @request POST: /api/v1/PendingSerieReason
     * @secure
     */
    createNewPendingSerialReason: (
      data: { description: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PendingSerieReason`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags EditNewPendingSerialReason
     * @name EditNewPendingSerialReason
     * @request PUT: /api/v1/PendingSerieReason
     * @secure
     */
    editNewPendingSerialReason: (
      data: PendingForSerialReasonUpdateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PendingSerieReason`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags DeletePendingSerialReason
     * @name DeletePendingSerialReason
     * @request DELETE: api/v1/PendingSerieReason/1
     * @secure
     */
    deletePendingSerialReason: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PendingSerieReason/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  partner: {
    /**
     * @tags getAllPartnersEnabled
     * @name getAllPartnersEnabled
     * @request GET: /api/v1/Partner
     * @secure
     */
    getAllPartnersEnabled: (
      params: { onlyEnabled?: boolean },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PartnerResponse[]>>({
        url: `/Partner`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags getPartnerByUserId
     * @name getPartnerByUserId
     * @request GET: /api/v1/Partner/PartnersByUser?UserId=????
     * @secure
     */
    getPartnerByUserId: (
      params: { userId?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PartnerByUserId[]>>({
        url: `/Partner/PartnersByUser`,
        method: 'GET',
        params,
        paramsSerializer: (prms) =>
          qs.stringify(prms, { arrayFormat: 'repeat' }),
        ...config
      })
  },
  irreparableReason: {
    /**
     * @tags GeneralSearch
     * @name GeneralSearch
     * @request GET: /api/v1/IrreparableReason/GeneralSearch
     * @secure
     */
    generalSearch: (params: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<PendingForSerialReason>>
      >({
        url: `/IrreparableReason/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags CreateIrreparableReason
     * @name CreateIrreparableReason
     * @request POST: /api/v1/IrreparableReason
     * @secure
     */
    createIrreparableReason: (
      data: { description: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/IrreparableReason`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags EditIrreparableReason
     * @name EditIrreparableReason
     * @request PUT: /api/v1/IrreparableReason
     * @secure
     */
    editIrreparableReason: (
      data: IrreparableReasonUpdateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/IrreparableReason`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags DeleteIrreparableReason
     * @name DeleteIrreparableReason
     * @request DELETE: api/v1/IrreparableReason/1
     * @secure
     */
    deleteIrreparableReason: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/IrreparableReason/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * @tags GetAllIrreparableReasons
     * @name GetAllIrreparableReasons
     * @request GET: api/v1/IrreparableReason/GetAll
     * @secure
     */
    getAllIrreparableReasons: (config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<
          { name: string; id: number; description: string }[]
        >
      >({
        url: `/IrreparableReason/GetAll`,
        method: 'GET',
        ...config
      })
  },
  audit: {
    /**
     * Obtiene un listado de tipos de auditoría
     * @tags getAllAuditTypes
     * @name getAllAuditTypes
     * @request GET: api/v1/AuditType
     * @secure
     */
    getAllAuditTypes: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AuditType[]>>({
        url: `/AuditType`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtiene un listado paginado de los tipos de auditorías
     * @tags generalSearchAudit
     * @name generalSearchAudit
     * @request POST: api/v1/AuditType/SearchAuditTypes
     * @secure
     */
    generalSearchAudit: (
      data: RequestGeneralSearchAudit,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ResponseGeneralSearchAuditType[]>>
      >({
        url: `/AuditType/SearchAuditTypes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea un nuevo tipo de auditoría
     * @tags createNewAuditType
     * @name createNewAuditType
     * @request POST: api/v1/AuditType
     * @secure
     */
    createNewAuditType: (
      data: { description: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/AuditType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza una auditoría
     * @tags editAuditType
     * @name editAuditType
     * @request PUT: api/v1/AuditType
     * @secure
     */
    editAuditType: (
      data: RequestUpdateAuditType,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/AuditType`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Elimina una auditoría
     * @tags deleteAuditType
     * @name deleteAuditType
     * @request DELETE: api/v1/AuditType
     * @secure
     */
    deleteAuditType: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/AuditType/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  wareHouseTypes: {
    /**
     * Obtiene un listado de tipos de Almacen activos
     * @tags warehouseTypes
     * @name get
     * @request GET:/api/v1/WarehousesTypes
     * @secure
     */
    getActive: (params = {}, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/WarehouseType`,
        method: 'GET',
        params: { ...params },
        ...config
      }),
    /**
     * Obtiene un listado de tipos de Almacen
     * @tags getAllWarehouseTypes
     * @name getAllWarehouseTypes
     * @request POST: api/v1/WarehouseType/SearchWarehouseType
     * @secure
     */
    getAllWarehouseTypes: (
      data: WareHouseTypeRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<WareHouseTypeResponse[]>>
      >({
        url: `/WarehouseType/SearchWarehouseType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea un nuevo tipo de Almacen
     * @tags  createNewWarehouseTypes
     * @name  createNewWarehouseTypes
     * @request POST: api/v1/WarehouseType
     * @secure
     */
    createNewWarehouseTypes: (
      data: WareHouseTypeCreateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/WarehouseType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza un tipo de Almacen
     * @tags  updateWarehouseTypes
     * @name  updateWarehouseTypes
     * @request PUT: api/v1/WarehouseType
     * @secure
     */
    updateWarehouseTypes: (
      data: WareHouseTypeUpdateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/WarehouseType`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Elimina un tipo de Almacen
     * @tags deleteWareHouseType
     * @name deleteWareHouseType
     * @request DELETE: api/v1/WarehouseType
     * @secure
     */
    deleteWareHouseType: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/WarehouseType/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  unitsMeasurements: {
    /**
     * Obtiene un listado de tipos de Almacen
     * @tags getAllUnitsMeasurement
     * @name getAllUnitsMeasurement
     * @request POST: api/v1/UnitMeasurement/GeneralSearch
     * @secure
     */
    getAllUnitsMeasurement: (
      data: UnitsMeasurementRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<UnitsMeasurementResponse[]>>
      >({
        url: `/UnitMeasurement/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea un nuevo tipo de Almacen
     * @tags  createNewUnitsMeasurement
     * @name  createNewUnitsMeasurement
     * @request POST: api/v1/UnitMeasurement
     * @secure
     */
    createNewUnitsMeasurement: (
      data: UnitsMeasurementCreateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/UnitMeasurement`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza un tipo de Almacen
     * @tags  updateUnitsMeasurement
     * @name  updateUnitsMeasurement
     * @request PUT: api/v1/UnitMeasurement
     * @secure
     */
    updateUnitsMeasurement: (
      data: UnitsMeasurementUpdateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/UnitMeasurement`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Elimina un tipo de Almacen
     * @tags deleteUnitsMeasurement
     * @name deleteUnitsMeasurement
     * @request DELETE: api/v1/UnitMeasurement
     * @secure
     */
    deleteUnitsMeasurement: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/UnitMeasurement/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  notifications: {
    /**
     * Obtiene un listado de prioridades de notificaciones
     * @tags notificationPriority
     * @name get
     * @request GET:/api/v1/NotificationPriority
     * @secure
     */
    getAllNotificationPriority: (
      params = {},
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<NotificationPriorityAndTypeData[]>
      >({
        url: `/NotificationPriority`,
        method: 'GET',
        params: { ...params },
        ...config
      }),

    /**
     * Obtiene un listado de tipos de notificaciones
     * @tags notificationType
     * @name get
     * @request GET:/api/v1/NotificationType
     * @secure
     */
    getAllNotificationType: (params = {}, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<NotificationPriorityAndTypeData[]>
      >({
        url: `/NotificationType`,
        method: 'GET',
        params: { ...params },
        ...config
      })
  },
  tagCode: {
    /**
     * Obtiene un listado de Folios TAGS
     * @tags Folio Tags
     * @name getAllTagsCodes
     * @request POST: /api/v1/TagCode/SearchTagCodes
     * @secure
     */
    getAllTagsCodes: (
      data: GetTagCodesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetTagCodesResponse[]>>
      >({
        url: `/TagCode/SearchTagCodes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Creacion de un nuevo Folios TAGS
     * @tags Folio Tags
     * @name createNewFolioTag
     * @request POST: /api/v1/TagCode
     * @secure
     */
    createNewFolioTag: (
      data: CreateFolioTag,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/TagCode`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edicion de un Folios TAGS
     * @tags Folio Tags
     * @name editFolioTag
     * @request PUT: /api/v1/TagCode
     * @secure
     */
    editFolioTag: (data: EditTagCode, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/TagCode`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Eliminacion de un Folios TAGS
     * @tags Folio Tags
     * @name deleteFolioTag
     * @request DELETE: /api/v1/TagCode
     * @secure
     */
    deleteFolioTag: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/TagCode/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  fuelCode: {
    /**
     * Obtiene un listado de Folios de Combustible
     * @tags Folio Fuel
     * @name getAllFuelCodes
     * @request POST: /api/v1/FuelCode/SearchFuelCodes
     * @secure
     */
    getAllFuelCodes: (
      data: GetFuelCodesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetTagCodesResponse[]>>
      >({
        url: `/FuelCode/SearchFuelCodes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Creacion de un nuevo Folios de Combustible
     * @tags Folio Fuel
     * @name createNewFolioFuel
     * @request POST: /api/v1/FuelCode
     * @secure
     */
    createNewFolioFuel: (
      data: CreateFolioFuel,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FuelCode`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edicion de un Folios de Combustible
     * @tags Folio Fuel
     * @name editFolioFuel
     * @request PUT: /api/v1/FuelCode
     * @secure
     */
    editFolioFuel: (data: EditFuelCode, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FuelCode`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Eliminacion de un Folios de Combustible
     * @tags Folio Fuel
     * @name deleteFolioFuel
     * @request DELETE: /api/v1/FuelCode
     * @secure
     */
    deleteFolioFuel: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FuelCode/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Eliminacion y creacion de un Folios de Combustible
     * @tags Folio Fuel
     * @name deleteAndCreateFolioFuel
     * @request POST: /api/v1/FuelCode/DeleteAndCreateFuelCodes
     * @secure
     */
    deleteAndCreateFolioFuel: (
      data: DeleteAndCreateFolioFuel,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FuelCode/DeleteAndCreateFuelCodes`,
        method: 'POST',
        data,
        ...config
      })
  },
  expenseCode: {
    /**
     * Obtiene un listado de Folios de Viaticos
     * @tags Folio Fuel
     * @name getAllExpenseCode
     * @request POST: /api/v1/ExpenseCode/SearchExpenseCodes
     * @secure
     */
    getAllExpenseCode: (
      data: GetExpenseCodeRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetExpenseCodeResponse[]>>
      >({
        url: `/ExpenseCode/SearchExpenseCodes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Creacion de un nuevo Folios de Viaticos
     * @tags Folio Fuel
     * @name createNewFolioExpenseCode
     * @request POST: /api/v1/ExpenseCode
     * @secure
     */
    createNewFolioExpenseCode: (
      data: CreateFolioExpenseCode,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ExpenseCode`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edicion de un Folios de Viaticos
     * @tags Folio Fuel
     * @name editFolioExpenseCode
     * @request PUT: /api/v1/ExpenseCode
     * @secure
     */
    editFolioExpenseCode: (
      data: EditExpenseCode,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ExpenseCode`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Eliminacion de un Folios de Viaticos
     * @tags Folio Fuel
     * @name deleteFolioExpenseCode
     * @request DELETE: /api/v1/ExpenseCode
     * @secure
     */
    deleteFolioExpenseCode: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ExpenseCode/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Eliminacion y creacion de un Folios de Viaticos
     * @tags Folio Fuel
     * @name deleteAndCreateExpenseCodeBulkLoad
     * @request POST: /api/v1/ExpenseCode/DeleteAndCreateExpenseCodes
     * @secure
     */
    deleteAndCreateExpenseCodeBulkLoad: (
      data: DeleteAndCreateFolioExpenseCode,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ExpenseCode/DeleteAndCreateExpenseCodes`,
        method: 'POST',
        data,
        ...config
      })
  },
  reports: {
    /**
     * Obtiene un listado de Reportes
     * @tags Reportes
     * @name getAllDashboard
     * @request POST: /api/v1/Dashboard/SearchDashboards
     * @secure
     */
    getAllDashboard: (
      data: GetDashboardRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetDashboardResponse[]>>
      >({
        url: `/Dashboard/SearchDashboards`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Creacion de un nuevo Reportes
     * @tags Reportes
     * @name createNewFolioDashboard
     * @request POST: /api/v1/Dashboard
     * @secure
     */
    createNewFolioDashboard: (
      data: CreateDashboard,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Dashboard`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Edicion de un Reportes
     * @tags Reportes
     * @name editFolioDashboard
     * @request PUT: /api/v1/Dashboard
     * @secure
     */
    editFolioDashboard: (
      data: EditDashboard,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Dashboard`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Eliminacion de un Reportes
     * @tags Reportes
     * @name deleteFolioDashboard
     * @request DELETE: /api/v1/Dashboard
     * @secure
     */
    deleteFolioDashboard: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Dashboard/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  Forms: {
    /**
     * Obtener todos los fields custom
     *
     * @tags getAllTFieldsCostum
     * @name getAllTFieldsCostum
     * @request GET:/api/v1/Forms/${id}/fields
     * @secure
     */
    getAllFieldsCostum: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ListCurrenciesResponse[]>>({
        url: `/Forms/${id}/fields`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtener los tipos
     *
     * @tags getAllTypeItemsCostum
     * @name getAllTypeItemsCostum
     * @request GET:/api/v1/Forms/types
     * @secure
     */
    getAllTypeItemsCostum: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ListCurrenciesResponse[]>>({
        url: `/Forms/types`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtener los forms (componente de configuración, ubicaciones y usuarios)
     *
     * @tags GetFieldsByFormId
     * @name getFormCustom
     * @request POST:/api/v1/Forms/GetFieldsByFormId
     * @secure
     */

    getFormCustom: (data: FormCustomRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, ServiceResponse<ResponseForm>>({
        url: `/Forms/GetFieldsByFormId`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualizar formularios Custom (componente de configuración, ubicaciones y usuarios)
     *
     * @tags PutFormCustom
     * @name putFormCustom
     * @request POST:/api/v1/Forms/{id}
     * @secure
     */

    putFormCustom: (
      id: number,
      data: object,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Forms/${id}`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Actualizar un item del formulario Custom (componente de configuración, ubicaciones y usuarios)
     *
     * @tags patchFormCustom
     * @name patchFormCustom
     * @request POST:/api/v1/Forms/field
     * @secure
     */

    patchFormCustom: (data: object, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Forms/field`,
        method: 'PATCH',
        data,
        ...config
      }),
    /**
     * Eliminacion de un item form
     * @tags Formularios custom
     * @name deleteItemFormCustom
     * @request DELETE: /Forms/field/{id}
     * @secure
     */
    deleteItemFormCustom: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Forms/field/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  language: {
    /**
     * Obtiene todos los lenguajes
     * @tags Reportes
     * @name getAllLanguages
     * @request GET: api/v1/Language/GetAllLanguages
     * @secure
     */
    getAllLanguages: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetAllLanguages[]>>({
        url: `/Language/GetAllLanguages`,
        method: 'GET',
        ...config
      })
  },
  serviceClass: {
    /**
     * getAll
     * @tags Reportes
     * @name getAll
     * @request GET: api/v1/ServiceClass
     * @secure
     */
    getAll: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceClassResponse[]>>({
        url: `/ServiceClass`,
        method: 'GET',
        ...config
      }),
    /**
     * GeneralSearch
     * @tags Reportes
     * @name generalSearch
     * @request POST: api/v1/ServiceClass/GetServiceClasses
     * @secure
     */
    generalSearchServiceClass: (
      data: ServiceClassParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ServiceClassResponse>>
      >({
        url: `/ServiceClass/GetServiceClasses`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * create ServiceClass
     * @tags Reportes
     * @name create
     * @request POST: api/v1/ServiceClass
     * @secure
     */
    create: (
      data: { name: string; isTowerService?: boolean },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ServiceClass`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * delete ServiceClass
     * @tags Reportes
     * @name delete
     * @request DELETE: api/v1/ServiceClass
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ServiceClass/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * update ServiceClass
     * @tags Reportes
     * @name update
     * @request PUT: api/v1/ServiceClass
     * @secure
     */
    update: (
      data: {
        serviceClassId: number;
        name: string;
        isTowerService?: boolean;
        enabled: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ServiceClass`,
        method: 'PUT',
        data,
        ...config
      })
  },
  changeService: {
    /**
     * getAll
     * @tags Estado del cambio
     * @name getAll
     * @request GET: api/v1/ChangeStageStatus/StageGetAll
     * @secure
     */
    getAll: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ChangeTypesResponse[]>>({
        url: `/ChangeService`,
        method: 'GET',
        ...config
      })
  },
  changeType: {
    /**
     * getAll
     * @tags Estado del cambio
     * @name getAll
     * @request GET: api/v1/ChangeStageStatus/StageGetAll
     * @secure
     */
    getAll: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ChangeTypesResponse[]>>({
        url: `/ChangeType/GetAllChangeTypes`,
        method: 'GET',
        ...config
      }),
    /**
     * GeneralSearch ChangeType
     * @tags Reportes
     * @name generalSearch
     * @request POST: api/v1/ChangeType/SearchChangeTypes
     * @secure
     */
    generalSearchChangeTypes: (
      data: ChangeTypeParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ChangeTypesResponse>>
      >({
        url: `/ChangeType/SearchChangeTypes`,
        method: 'POST',
        params: data,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
        ...config
      }),
    /**
     * Get ChangeType by id
     * @tags Reportes
     * @name getById
     * @request GET: api/v1/ChangeType/${id}
     * @secure
     */
    getById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ChangeTypesResponse>>({
        url: `/ChangeType/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Get ChangeType by id
     * @tags Reportes
     * @name getById
     * @request GET: api/v1/ChangeType/${id}
     * @secure
     */
    getStageById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ChangeTypesResponse>>({
        url: `/ChangeStageStatus/StageGetById/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * create ChangeType
     * @tags Reportes
     * @name create
     * @request POST: api/v1/ChangeType
     * @secure
     */
    create: (
      data: { name: string; description: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * delete ChangeType
     * @tags Reportes
     * @name delete
     * @request DELETE: api/v1/ChangeType/${id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeType/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * update ChangeType
     * @tags Reportes
     * @name update
     * @request PUT: api/v1/ChangeType
     * @secure
     */
    update: (data: ChangeTypesEditResponse, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeType`,
        method: 'PUT',
        data,
        ...config
      })
  },
  changeStageStatus: {
    /**
     * getAll
     * @tags Estado del cambio
     * @name getAll
     * @request GET: api/v1/ChangeStageStatus/StageGetAll
     * @secure
     */
    getAll: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ChangeStageStatusResponse[]>>(
        {
          url: `/ChangeStageStatus/StageGetAll`,
          method: 'GET',
          ...config
        }
      ),
    /**
     * GeneralSearch change Stage
     * @tags Reportes
     * @name generalSearch
     * @request POST: api/v1/ChangeStageStatus/StageGeneralSearch
     * @secure
     */
    stageGeneralSearch: (
      data: ChangeStageStatusParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ChangeStageStatusResponse>>
      >({
        url: `/ChangeStageStatus/StageGeneralSearch`,
        method: 'POST',
        data,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
        ...config
      }),
    /**
     * GeneralSearch change Status
     * @tags Reportes
     * @name generalSearchStatus
     * @request POST: api/v1/ChangeStageStatus/StageGetById/1

     * @secure
     */
    generalSearchStatus: (
      data: ChangeStatusParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ChangeStatusResponse>>
      >({
        url: `/ChangeStageStatus/StatusGetByStageId`,
        method: 'POST',
        data,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
        ...config
      }),
    /**
     * Get all active stages
     * @tags ChangeStageStatus
     * @name getAllStages
     * @request GET: /api/v1/ChangeStageStatus/StageGetAll
     * @secure
     */
    getAllStages: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ChangeStatusResponse>>({
        url: `/ChangeStageStatus/StageGetAll`,
        method: 'GET',
        ...config
      }),
    /**
     * Get change Stage Status by id
     * @tags Reportes
     * @name getById
     * @request GET: api/v1/ChangeType/${id}
     * @secure
     */
    getById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ChangeTypesResponse>>({
        url: `/ChangeType/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * create change Stage
     * @tags Reportes
     * @name createNewStage
     * @request POST: api/v1/ChangeStageStatus/StagePost
     * @secure
     */
    createNewStage: (data: CreateNewStage, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeStageStatus/StagePost`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * create change Status
     * @tags Reportes
     * @name create
     * @request POST: api/v1/ChangeStageStatus/StatusPost
     * @secure
     */
    create: (data: CreateNewStatus, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeStageStatus/StatusPost`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * delete change Stage Status
     * @tags Reportes
     * @name delete
     * @request DELETE: api/v1/ChangeStageStatus/StatusDelete/${id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeStageStatus/StatusDelete/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * delete change Status
     * @tags Reportes
     * @name deleteStage
     * @request DELETE: api/v1/ChangeStageStatus/StageDelete/${id}
     * @secure
     */
    deleteStage: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeStageStatus/StageDelete/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * update change Stage
     * @tags Reportes
     * @name updateStage
     * @request PUT: api/v1/ChangeStageStatus/StagePut

     * @secure
     */
    updateStage: (data: EditStage, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeStageStatus/StagePut`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * update change Status
     * @tags Reportes
     * @name update
     * @request PUT: api/v1/ChangeStageStatus/StatusPut

     * @secure
     */
    update: (data: EditStatus, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ChangeStageStatus/StatusPut`,
        method: 'PUT',
        data,
        ...config
      })
  },
  taskStatus: {
    /**
     * Get all task status
     * @tags Reportes
     * @name getAllTaskStatus
     * @request GET: api/v1/TaskStatus?onlyEnabled=true
     * @secure
     */
    getAllTaskStatus: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TaskStatusResponse[]>>({
        url: `/TaskStatus?onlyEnabled=true`,
        method: 'GET',
        ...config
      })
  },
  TaskType: {
    /**
     * Get all task Types
     * @tags Reportes
     * @name getAllTaskType
     * @request GET: api/v1/TaskType?onlyEnabled=true
     * @secure
     */
    getAllTaskType: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TaskTypeResponse[]>>({
        url: `/TaskType?onlyEnabled=true`,
        method: 'GET',
        ...config
      })
  },
  TaskStatus: {
    /**
     * Get all task Status
     * @tags Reportes
     * @name generalSearchTaskStatus
     * @request GET: api/v1/TaskStatus/SearchTaskStatus
     * @secure
     */
    generalSearchTaskStatus: (
      params: SearchTaskStatusRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchTaskStatusResponse>>
      >({
        url: `/TaskStatus/SearchTaskStatus`,
        method: 'GET',
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
        ...config
      })
  },
  solutionTopics: {
    /**
     * Get all solution topics
     * @tags SolutionTopics
     * @name getAllSolutionTopics
     * @request GET: api/v1/SolutionTopic
     * @secure
     */
    getAllSolutionTopics: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SolutionTopicsResponse[]>>({
        url: `/SolutionTopic?onlyEnabled=true`,
        method: 'GET',
        ...config
      })
  }
};
